// -------------live url
// export const apiBaseUrl =
//   `https://mob.madoverbuilding.com` || process.env.REACT_APP_BASE_URL;

// export const demandRupifiUrl = `https://madoverbuildings.com/home/checkout?checkout_url=`;
// export const showDemandRupifiUrl = `https://madoverbuildings.com`;
// export const baseUrl = ``;

// -------------Staging url
export const apiBaseUrl = `https://staging.madoverbuilding.com`;
export const baseUrl = ``;
export const demandRupifiUrl = `https://staging.madoverbuildings.com/home/checkout?checkout_url=`;
export const showDemandRupifiUrl = `https://staging.madoverbuildings.com`;

// -------------local url
// export const apiBaseUrl = `https://uat.madoverbuilding.com`;
// export const baseUrl = ``;

// -------------local url
// export const apiBaseUrl = `https://uat.madoverbuilding.com`;
// export const baseUrl = ``;

// -------------local url
// export const apiBaseUrl = `https://uat.madoverbuilding.com`;
// export const baseUrl = ``;

// -------------local url
// export const apiBaseUrl = `https://uat.madoverbuilding.com`;
// export const baseUrl = ``;

// export const demandRupifiUrl = `https://mob-demand-side.netlify.app/home/checkout?checkout_url=`;
// export const showDemandRupifiUrl = `https://mob-demand-side.netlify.app`;

export const gstRegex = /^(?:[0-3|9][0-9])[a-zA-Z0-9]{13}$/;
// export const gstRegex = /^[0-9]{2}[a-zA-z0-9]{13}$/;
export const rupifiStatusCheck = ["ACTIVE", "REJECTED","INACTIVE","PRE_APPROVED","INCOMPLETE","UNDER_REVIEW"];
export const mobDirectStatusCheck = ["active","in_progress","inactive","blocked","overdue","closed","rejected"];
export const genderOption = [
  {
    key: 1,
    label: "Male",
    value: "Male",
  },
  {
    key: 2,
    label: "Female",
    value: "Female",
  },
  {
    key: 3,
    label: "Others",
    value: "Others",
  },
];
export const serviceRequestStatusOption = [
  {
    key: 1,
    label: "Registered",
    value: "Registered",
  },
  {
    key: 2,
    label: "In Progress",
    value: "In Progress",
  },
  {
    key: 3,
    label: "Resolved",
    value: "Resolved",
  },
  {
    key: 4,
    label: "Redundant",
    value: "Redundant",
  },
];
export const issueTypeOptions = [
  {key: "1", value: "Damaged Product", label: "Damaged Product"},
  {key: "2", value: "Quantity Issue", label: "Quantity Issue"},
  {key: "3", value: "Wrong Material Sent", label: "Wrong Material Sent"},
  {
    key: "4",
    value: "Under Warranty Service Requests",
    label: "Under Warranty Service Requests",
  },
  {
    key: "5",
    value: "Installation/Working Issue",
    label: "Installation/Working Issue",
  },
  {key: "6", value: "Return Request", label: "Return Request"},
  {key: "7", value: "Invoice Amount Issue", label: "Invoice Amount Issue"},
  {key: "8", value: "Payment Capture Issue", label: "Payment Capture Issue"},
  {key: "9", value: "Replacement Request", label: "Replacement Request"},
  {key: "10", value: "Other", label: "Other"},
];

export const amountType = [
  {
    key: 1,
    label: "Add",
    value: "CREDIT",
  },
  {
    key: 2,
    label: "Deduct",
    value: "DEBIT",
  },
];
export const cityOptions = [
  { key: 1, label: "Delhi", value: "Delhi", state: "Delhi" },
  { key: 2, label: "Mumbai", value: "Mumbai", state: "Maharashtra" },
  { key: 3, label: "Kolkata", value: "Kolkata", state: "West Bengal" },
  { key: 4, label: "Bengaluru", value: "Bengaluru", state: "Karnataka" },
  { key: 5, label: "Chennai", value: "Chennai", state: "Tamil Nadu" },
  { key: 6, label: "Hyderabad", value: "Hyderabad", state: "Telangana" },
  { key: 7, label: "Pune", value: "Pune", state: "Maharashtra" },
  { key: 8, label: "Ahmedabad", value: "Ahmedabad", state: "Gujarat" },
  { key: 9, label: "Surat", value: "Surat", state: "Gujarat" },
  { key: 10, label: "Lucknow", value: "Lucknow", state: "Uttar Pradesh" },
  { key: 11, label: "Jaipur", value: "Jaipur", state: "Rajasthan" },
  { key: 12, label: "Kanpur", value: "Kanpur", state: "Uttar Pradesh" },
  { key: 13, label: "Mirzapur", value: "Mirzapur", state: "Uttar Pradesh" },
  { key: 14, label: "Nagpur", value: "Nagpur", state: "Maharashtra" },
  { key: 15, label: "Ghaziabad", value: "Ghaziabad", state: "Uttar Pradesh" },
  { key: 16, label: "Supaul", value: "Supaul", state: "Bihar" },
  { key: 17, label: "Vadodara", value: "Vadodara", state: "Gujarat" },
  { key: 18, label: "Rajkot", value: "Rajkot", state: "Gujarat" },
  { key: 19, label: "Visakhapatnam", value: "Visakhapatnam", state: "Andhra Pradesh" },
  { key: 20, label: "Indore", value: "Indore", state: "Madhya Pradesh" },
  { key: 21, label: "Thane", value: "Thane", state: "Maharashtra" },
  { key: 22, label: "Bhopal", value: "Bhopal", state: "Madhya Pradesh" },
  { key: 23, label: "Pimpri-Chinchwad", value: "Pimpri-Chinchwad", state: "Maharashtra" },
  { key: 24, label: "Patna", value: "Patna", state: "Bihar" },
  { key: 25, label: "Bilaspur", value: "Bilaspur", state: "Chhattisgarh" },
  { key: 26, label: "Ludhiana", value: "Ludhiana", state: "Punjab" },
  { key: 27, label: "Agra", value: "Agra", state: "Uttar Pradesh" },
  { key: 28, label: "Madurai", value: "Madurai", state: "Tamil Nadu" },
  { key: 29, label: "Jamshedpur", value: "Jamshedpur", state: "Jharkhand" },
  { key: 30, label: "Prayagraj", value: "Prayagraj", state: "Uttar Pradesh" },
  { key: 31, label: "Nashik", value: "Nashik", state: "Maharashtra" },
  { key: 32, label: "Faridabad", value: "Faridabad", state: "Haryana" },
  { key: 33, label: "Meerut", value: "Meerut", state: "Uttar Pradesh" },
  { key: 34, label: "Jabalpur", value: "Jabalpur", state: "Madhya Pradesh" },
  { key: 35, label: "Kalyan", value: "Kalyan", state: "Maharashtra" },
  { key: 36, label: "Vasai-Virar", value: "Vasai-Virar", state: "Maharashtra" },
  { key: 37, label: "Najafgarh", value: "Najafgarh", state: "Delhi" },
  { key: 38, label: "Varanasi", value: "Varanasi", state: "Uttar Pradesh" },
  { key: 39, label: "Srinagar", value: "Srinagar", state: "Jammu and Kashmir" },
  { key: 40, label: "Aurangabad", value: "Aurangabad", state: "Maharashtra" },
  { key: 41, label: "Dhanbad", value: "Dhanbad", state: "Jharkhand" },
  { key: 42, label: "Amritsar", value: "Amritsar", state: "Punjab" },
  { key: 43, label: "Aligarh", value: "Aligarh", state: "Uttar Pradesh" },
  { key: 44, label: "Guwahati", value: "Guwahati", state: "Assam" },
  { key: 45, label: "Howrah", value: "Howrah", state: "West Bengal" },
  { key: 46, label: "Ranchi", value: "Ranchi", state: "Jharkhand" },
  { key: 47, label: "Gwalior", value: "Gwalior", state: "Madhya Pradesh" },
  { key: 48, label: "Chandigarh", value: "Chandigarh", state: "Chandigarh" },
  { key: 49, label: "Haldwani", value: "Haldwani", state: "Uttarakhand" },
  { key: 50, label: "Vijayawada", value: "Vijayawada", state: "Andhra Pradesh" },
  { key: 51, label: "Jodhpur", value: "Jodhpur", state: "Rajasthan" },
  { key: 52, label: "Raipur", value: "Raipur", state: "Chhattisgarh" },
  { key: 53, label: "Kota", value: "Kota", state: "Rajasthan" },
  { key: 54, label: "Bhayandar", value: "Bhayandar", state: "Maharashtra" },
  { key: 55, label: "Loni", value: "Loni", state: "Uttar Pradesh" },
  { key: 56, label: "Ambattur", value: "Ambattur", state: "Tamil Nadu" },
  { key: 57, label: "Salt Lake City", value: "Salt Lake City", state: "West Bengal" },
  { key: 58, label: "Bhatpara", value: "Bhatpara", state: "West Bengal" },
  { key: 59, label: "Kukatpalli", value: "Kukatpalli", state: "Telangana" },
  { key: 60, label: "Dasarhalli", value: "Dasarhalli", state: "Karnataka" },
  { key: 61, label: "Muzaffarpur", value: "Muzaffarpur", state: "Bihar" },
  { key: 62, label: "Oulgaret", value: "Oulgaret", state: "Puducherry" },
  { key: 63, label: "New Delhi", value: "New Delhi", state: "Delhi" },
  { key: 64, label: "Tiruvottiyur", value: "Tiruvottiyur", state: "Tamil Nadu" },
  { key: 65, label: "Puducherry", value: "Puducherry", state: "Puducherry" },
  { key: 66, label: "Byatarayanpur", value: "Byatarayanpur", state: "Karnataka" },
  { key: 67, label: "Pallavaram", value: "Pallavaram", state: "Tamil Nadu" },
  { key: 68, label: "Secunderabad", value: "Secunderabad", state: "Telangana" },
  { key: 69, label: "Shimla", value: "Shimla", state: "Himachal Pradesh" },
  { key: 70, label: "Puri", value: "Puri", state: "Odisha" },
  { key: 71, label: "Murtazabad", value: "Murtazabad", state: "Karnataka" },
  { key: 72, label: "Shrirampur", value: "Shrirampur", state: "West Bengal" },
  { key: 73, label: "Chandannagar", value: "Chandannagar", state: "West Bengal" },
  { key: 74, label: "Sultampur Mazra", value: "Sultampur Mazra", state: "Uttar Pradesh" },
  { key: 75, label: "Krishnanagar", value: "Krishnanagar", state: "West Bengal" },
  { key: 76, label: "Barakpur", value: "Barakpur", state: "West Bengal" },
  { key: 77, label: "Bhalaswa Jahangirpur", value: "Bhalaswa Jahangirpur", state: "Delhi" },
  { key: 78, label: "Nangloi Jat", value: "Nangloi Jat", state: "Delhi" },
  { key: 79, label: "Balasore", value: "Balasore", state: "Odisha" },
  { key: 80, label: "Dalupura", value: "Dalupura", state: "Delhi" },
  { key: 81, label: "Yelahanka", value: "Yelahanka", state: "Karnataka" },
  { key: 82, label: "Titagarh", value: "Titagarh", state: "West Bengal" },
  { key: 83, label: "Dam Dam", value: "Dam Dam", state: "West Bengal" },
  { key: 84, label: "Bansbaria", value: "Bansbaria", state: "West Bengal" },
  { key: 85, label: "Madhavaram", value: "Madhavaram", state: "Tamil Nadu" },
  { key: 86, label: "Abbigeri", value: "Abbigeri", state: "Karnataka" },
  { key: 87, label: "Baj Baj", value: "Baj Baj", state: "West Bengal" },
  { key: 88, label: "Garhi", value: "Garhi", state: "Delhi" },
  { key: 89, label: "Mirpeta", value: "Mirpeta", state: "Telangana" },
  { key: 90, label: "Nerkunram", value: "Nerkunram", state: "Tamil Nadu" },
  { key: 91, label: "Kendrapara", value: "Kendrapara", state: "Odisha" },
  { key: 92, label: "Sijua", value: "Sijua", state: "Odisha" },
  { key: 93, label: "Manali", value: "Manali", state: "Himachal Pradesh" },
  { key: 94, label: "Kankuria", value: "Kankuria", state: "West Bengal" },
  { key: 95, label: "Chakapara", value: "Chakapara", state: "West Bengal" },
  { key: 96, label: "Pappakurichchi", value: "Pappakurichchi", state: "Tamil Nadu" },
  { key: 97, label: "Herohalli", value: "Herohalli", state: "Karnataka" },
  { key: 98, label: "Madipakkam", value: "Madipakkam", state: "Tamil Nadu" },
  { key: 99, label: "Sabalpur", value: "Sabalpur", state: "West Bengal" },
  { key: 100, label: "Bauria", value: "Bauria", state: "West Bengal" },
  { key: 101, label: "Salua", value: "Salua", state: "West Bengal" },
  { key: 102, label: "Chik Bnavar", value: "Chik Bnavar", state: "Karnataka" },
  { key: 103, label: "Jalhalli", value: "Jalhalli", state: "Karnataka" },
  { key:  104, label: "Chinnasekkadu", value: "Chinnasekkadu", state: "Tamil Nadu" },
  { key: 105, label: "Jethuli", value: "Jethuli", state: "Bihar" },
  { key: 106, label: "Nagtala", value: "Nagtala", state: "West Bengal" },
  { key: 107, label: "Pakri", value: "Pakri", state: "Bihar" },
  { key: 108, label: "Hunasamaranhalli", value: "Hunasamaranhalli", state: "Karnataka" },
  { key: 109, label: "Hesarghatta", value: "Hesarghatta", state: "Karnataka" },
  { key: 110, label: "Bommayapalaiyam", value: "Bommayapalaiyam", state: "Tamil Nadu" },
  { key: 111, label: "Gundur", value: "Gundur", state: "Karnataka" },
  { key: 112, label: "Punadih", value: "Punadih", state: "Bihar" },
  { key: 113, label: "Hariladih", value: "Hariladih", state: "Bihar" },
  { key: 114, label: "Alawalpur", value: "Alawalpur", state: "Uttar Pradesh" },
  { key: 115, label: "Madnaikanhalli", value: "Madnaikanhalli", state: "Karnataka" },
  { key: 116, label: "Bagalur", value: "Bagalur", state: "Karnataka" },
  { key: 117, label: "Kadiganahalli", value: "Kadiganahalli", state: "Karnataka" },
  { key: 118, label: "Khanpur Zabti", value: "Khanpur Zabti", state: "Uttar Pradesh" },
  { key: 119, label: "Mahuli", value: "Mahuli", state: "Madhya Pradesh" },
  { key: 120, label: "Zeyadah Kot", value: "Zeyadah Kot", state: "Uttar Pradesh" },
  { key: 121, label: "Arshakunti", value: "Arshakunti", state: "Karnataka" },
  { key: 122, label: "Mirchi", value: "Mirchi", state: "Karnataka" },
  { key: 123, label: "Sonudih", value: "Sonudih", state: "Bihar" },
  { key: 124, label: "Bayandhalli", value: "Bayandhalli", state: "Karnataka" },
  { key: 125, label: "Sondekoppa", value: "Sondekoppa", state: "Karnataka" },
  { key: 126, label: "Babura", value: "Babura", state: "Karnataka" },
  { key: 127, label: "Madavar", value: "Madavar", state: "Karnataka" },
  { key: 128, label: "Kadabgeri", value: "Kadabgeri", state: "Karnataka" },
  { key: 129, label: "Nanmangalam", value: "Nanmangalam", state: "Tamil Nadu" },
  { key: 130, label: "Taliganja", value: "Taliganja", state: "Karnataka" },
  { key: 131, label: "Tarchha", value: "Tarchha", state: "Karnataka" },
  { key: 132, label: "Belgharia", value: "Belgharia", state: "West Bengal" },
  { key: 133, label: "Kammanhalli", value: "Kammanhalli", state: "Karnataka" },
  { key: 134, label: "Ambapuram", value: "Ambapuram", state: "Andhra Pradesh" },
  { key: 135, label: "Sonnappanhalli", value: "Sonnappanhalli", state: "Karnataka" },
  { key: 136, label: "Kedihati", value: "Kedihati", state: "Karnataka" },
  { key: 137, label: "Doddajivanahalli", value: "Doddajivanah alli", state: "Karnataka" },
  { key: 138, label: "Simli Murarpur", value: "Simli Murarpur", state: "West Bengal" },
  { key: 139, label: "Sonawan", value: "Sonawan", state: "Uttar Pradesh" },
  { key: 140, label: "Devanandapur", value: "Devanandapur", state: "Karnataka" },
  { key: 141, label: "Tribeni", value: "Tribeni", state: "West Bengal" },
  { key: 142, label: "Huttanhalli", value: "Huttanhalli", state: "Karnataka" },
  { key: 143, label: "Nathupur", value: "Nathupur", state: "Haryana" },
  { key: 144, label: "Bali", value: "Bali", state: "Odisha" },
  { key: 145, label: "Vajarhalli", value: "Vajarhalli", state: "Karnataka" },
  { key: 146, label: "Alija Kotla", value: "Alija Kotla", state: "Karnataka" },
  { key: 147, label: "Saino", value: "Saino", state: "Karnataka" },
  { key: 148, label: "Shekhpura", value: "Shekhpura", state: "Bihar" },
  { key: 149, label: "Cachoha", value: "Cachoha", state: "Uttar Pradesh" },
  { key: 150, label: "Andheri", value: "Andheri", state: "Maharashtra" },
  { key: 151, label: "Narayanpur Kola", value: "Narayanpur Kola", state: "Karnataka" },
  { key: 152, label: "Gyan Chak", value: "Gyan Chak", state: "Bihar" },
  { key: 153, label: "Kasgatpur", value: "Kasgatpur", state: "Karnataka" },
  { key: 154, label: "Kitanelli", value: "Kitanelli", state: "Karnataka" },
  { key: 155, label: "Harchandi", value: "Harchandi", state: "Karnataka" },
  { key: 156, label: "Santoshpur", value: "Santoshpur", state: "West Bengal" },
  { key: 157, label: "Bendravadi", value: "Bendravadi", state: "Karnataka" },
  { key: 158, label: "Kodagihalli", value: "Kodagihalli", state: "Karnataka" },
  { key: 159, label: "Harna Buzurg", value: "Harna Buzurg", state: "Uttar Pradesh" },
  { key: 160, label: "Mailanhalli", value: "Mailanhalli", state: "Karnataka" },
  { key: 161, label: "Sultampur", value: "Sultampur", state: "Uttar Pradesh" },
  { key: 162, label: "Adakimaranhalli", value: "Adakimaranhalli", state: "Karnataka" },
  { key: 163, label: "Delhi NCR", value: "Delhi NCR", state: "Delhi" },
    { key: 164, label: "Coimbatore", value: "Coimbatore", state: "Tamil Nadu" },
    { key: 165, label: "Mysuru", value: "Mysuru", state: "Karnataka" },
    { key: 166, label: "Bhubaneswar", value: "Bhubaneswar", state: "Odisha" },
    { key: 167, label: "Dehradun", value: "Dehradun", state: "Uttarakhand" },
    { key: 168, label: "Noida", value: "Noida", state: "Uttar Pradesh" },
    { key: 169, label: "Gurugram", value: "Gurugram", state: "Haryana" },
    { key: 170, label: "Greater Noida", value: "Greater Noida", state: "Uttar Pradesh" },
    { key: 171, label: "Siliguri", value: "Siliguri", state: "West Bengal" },
    { key: 172, label: "Tiruchirappalli", value: "Tiruchirappalli", state: "Tamil Nadu" },
    { key: 173, label: "Jalandhar", value: "Jalandhar", state: "Punjab" },
    { key: 174, label: "Udaipur", value: "Udaipur", state: "Rajasthan" },
    { key: 175, label: "Bareilly", value: "Bareilly", state: "Uttar Pradesh" },
    { key: 176, label: "Guntur", value: "Guntur", state: "Andhra Pradesh" },
    { key: 177, label: "Warangal", value: "Warangal", state: "Telangana" },
    { key: 178, label: "Kollam", value: "Kollam", state: "Kerala" },
    { key: 179, label: "Thiruvananthapuram", value: "Thiruvananthapuram", state: "Kerala" },
    { key: 180, label: "Mangalore", value: "Mangalore", state: "Karnataka" },
    { key: 181, label: "Bhavnagar", value: "Bhavnagar", state: "Gujarat" },
    { key: 182, label: "Amravati", value: "Amravati", state: "Maharashtra" },
    { key: 183, label: "Solapur", value: "Solapur", state: "Maharashtra" },
    { key: 184, label: "Cuttack", value: "Cuttack", state: "Odisha" },
    { key: 185, label: "Durgapur", value: "Durgapur", state: "West Bengal" },
    { key: 186, label: "Asansol", value: "Asansol", state: "West Bengal" },
    { key: 187, label: "Ajmer", value: "Ajmer", state: "Rajasthan" },
    { key: 188, label: "Nellore", value: "Nellore", state: "Andhra Pradesh" },
    { key: 189, label: "Kurnool", value: "Kurnool", state: "Andhra Pradesh" },
    { key: 190, label: "Belgaum", value: "Belgaum", state: "Karnataka" },
    { key: 191, label: "Gulbarga", value: "Gulbarga", state: "Karnataka" },
    { key: 192, label: "Erode", value: "Erode", state: "Tamil Nadu" },
    { key: 193, label: "Tirupati", value: "Tirupati", state: "Andhra Pradesh" },
    { key: 194, label: "Panipat", value: "Panipat", state: "Haryana" },
    { key: 195, label: "Rohtak", value: "Rohtak", state: "Haryana" },
    { key: 196, label: "Bokaro Steel City", value: "Bokaro Steel City", state: "Jharkhand" },
    { key: 197, label: "Moradabad", value: "Moradabad", state: "Uttar Pradesh" },
    { key: 198, label: "Saharanpur", value: "Saharanpur", state: "Uttar Pradesh" },
    { key: 199, label: "Gandhinagar", value: "Gandhinagar", state: "Gujarat" },
    { key: 200, label: "Vellore", value: "Vellore", state: "Tamil Nadu" },
    { key: 201, label: "Bhiwandi", value: "Bhiwandi", state: "Maharashtra" },
    { key: 202, label: "Sangli", value: "Sangli", state: "Maharashtra" },
    { key: 203, label: "Nanded", value: "Nanded", state: "Maharashtra" },
    { key: 204, label: "Kolhapur", value: "Kolhapur", state: "Maharashtra" },
    { key: 205, label: "Rourkela", value: "Rourkela", state: "Odisha" },
    { key: 206, label: "Bikaner", value: "Bikaner", state: "Rajasthan" },
    { key: 207, label: "Agartala", value: "Agartala", state: "Tripura" },
    { key: 208, label: "Ujjain", value: "Ujjain", state: "Madhya Pradesh" },
    { key: 209, label: "Jhansi", value: "Jhansi", state: "Uttar Pradesh" },
    { key: 210, label: "Davanagere", value: "Davanagere", state: "Karnataka" },
    { key: 211, label: "Kozhikode", value: "Kozhikode", state: "Kerala" },
    { key: 212, label: "Akola", value: "Akola", state: "Maharashtra" },
    { key: 213, label: "Bhilai", value: "Bhilai", state: "Chhattisgarh" },
    { key: 214, label: "Tirunelveli", value: "Tirunelveli", state: "Tamil Nadu" },
    { key: 215, label: "Malegaon", value: "Malegaon", state: "Maharashtra" },
    { key: 216, label: "Gaya", value: "Gaya", state: "Bihar" },
    { key: 217, label: "Jammu", value: "Jammu", state: "Jammu and Kashmir" },
    { key: 218, label: "Sikar", value: "Sikar", state: "Rajasthan" },
    { key: 219, label: "Bardhaman", value: "Bardhaman", state: "West Bengal" },
    { key: 220, label: "Kharagpur", value: "Kharagpur", state: "West Bengal" },
    { key: 221, label: "Dindigul", value: "Dindigul", state: "Tamil Nadu" },
    { key: 222, label: "Naihati", value: "Naihati", state: "West Bengal" },
    { key: 223, label: "Bally", value: "Bally", state: "West Bengal" },
    { key: 224, label: "Mathura", value: "Mathura", state: "Uttar Pradesh" },
    { key: 225, label: "Chittoor", value: "Chittoor", state: "Andhra Pradesh" },
    { key: 226, label: "Parbhani", value: "Parbhani", state: "Maharashtra" },
    { key: 227, label: "Tumakuru", value: "Tumakuru", state: "Karnataka" },
    { key: 228, label: "Shivamogga", value: "Shivamogga", state: "Karnataka" },
    { key: 229, label: "Bidar", value: "Bidar", state: "Karnataka" },
    { key: 230, label: "Nizamabad", value: "Nizamabad", state: "Telangana" },
    { key: 231, label: "Bettiah", value: "Bettiah", state: "Bihar" },
    { key: 232, label: "Bharatpur", value: "Bharatpur", state: "Rajasthan" },
    { key: 233, label: "Sambalpur", value: "Sambalpur", state: "Odisha" },
    { key: 234, label: "Hapur", value: "Hapur", state: "Uttar Pradesh" },
    { key: 235, label: "Raichur", value: "Raichur", state: "Karnataka" },
    { key: 236, label: "Shahjahanpur", value: "Shahjahanpur", state: "Uttar Pradesh" },
    { key: 237, label: "Satara", value: "Satara", state: "Maharashtra" },
    { key: 238, label: "Bijapur", value: "Bijapur", state: "Karnataka" },
    { key: 239, label: "Kakinada", value: "Kakinada", state: "Andhra Pradesh" },
    { key: 240, label: "Bhimavaram", value: "Bhimavaram", state: "Andhra Pradesh" },
    { key: 241, label: "Dewas", value: "Dewas", state: "Madhya Pradesh" },
    { key: 242, label: "Korba", value: "Korba", state: "Chhattisgarh" },
    { key: 243, label: "Nandyal", value: "Nandyal", state: "Andhra Pradesh" },
    { key: 244, label: "Bongaigaon", value: "Bongaigaon", state: "Assam" },
    { key: 245, label: "Bhimtal", value: "Bhimtal", state: "Uttarakhand" },
    { key: 246, label: "Patan", value: "Patan", state: "Gujarat" },
    { key: 247, label: "Rewa", value: "Rewa", state: "Madhya Pradesh" },
    { key: 248, label: "Bhusawal", value: "Bhusawal", state: "Maharashtra" },
    { key: 249, label: "Bhiwani", value: "Bhiwani", state: "Haryana" },
    { key: 250, label: "Ambala", value: "Ambala", state: "Haryana" },
    { key: 251, label: "Karaikudi", value: "Karaikudi", state: "Tamil Nadu" },
    { key: 252, label: "Panchkula", value: "Panchkula", state: "Haryana" },
    { key: 253, label: "Palakkad", value: "Palakkad", state: "Kerala" },
    { key: 254, label: "Jamnagar", value: "Jamnagar", state: "Gujarat" },
    { key: 255, label: "Junagadh", value: "Junagadh", state: "Gujarat" },
    { key: 256, label: "Anand", value: "Anand", state: "Gujarat" },
    { key: 257, label: "Nadiad", value: "Nadiad", state: "Gujarat" },
    { key: 258, label: "Navsari", value: "Navsari", state: "Gujarat" },
    { key: 259, label: "Bharuch", value: "Bharuch", state: "Gujarat" },
    { key: 260, label: "Valsad", value: "Valsad", state: "Gujarat" },
    { key: 261, label: "Vapi", value: "Vapi", state: "Gujarat" },
    { key: 262, label: "Morbi", value: "Morbi", state: "Gujarat" },
    { key: 263, label: "Mehsana", value: "Mehsana", state: "Gujarat" },
    { key: 264, label: "Bhuj", value: "Bhuj", state: "Gujarat" },
    { key: 265, label: "Porbandar", value: "Porbandar", state: "Gujarat" },
    { key: 266, label: "Surendranagar", value: "Surendranagar", state: "Gujarat" },
    { key: 267, label: "Veraval", value: "Veraval", state: "Gujarat" },
    { key: 268, label: "Godhra", value: "Godhra", state: "Gujarat" },
    { key: 269, label: "Palanpur", value: "Palanpur", state: "Gujarat" },
    { key: 270, label: "Dahod", value: "Dahod", state: "Gujarat" },
    { key: 271, label: "Amreli", value: "Amreli", state: "Gujarat" },
    { key: 272, label: "Rajpipla", value: "Rajpipla", state: "Gujarat" },
    { key: 273, label: "Botad", value: "Botad", state: "Gujarat" },
    { key: 274, label: "Deesa", value: "Deesa", state: "Gujarat" },
    { key: 275, label: "Kalol", value: "Kalol", state: "Gujarat" },
    { key: 276, label: "Kadi", value: "Kadi", state: "Gujarat" },
    { key: 277, label: "Mahuva", value: "Mahuva", state: "Gujarat" },
    { key: 278, label: "Ankleshwar", value: "Ankleshwar", state: "Gujarat" },
    { key: 279, label: "Pardi", value: "Pardi", state: "Gujarat" },
    { key: 280, label: "Sanand", value: "Sanand", state: "Gujarat" },
    { key: 281, label: "Himmatnagar", value: "Himmatnagar", state: "Gujarat" },
    { key: 282, label: "Modasa", value: "Modasa", state: "Gujarat" },
    { key: 283, label: "Vyara", value: "Vyara", state: "Gujarat" },
    { key: 284, label: "Lunawada", value: "Lunawada", state: "Gujarat" },
    { key: 285, label: "Khambhat", value: "Khambhat", state: "Gujarat" },
    { key: 286, label: "Dholka", value: "Dholka", state: "Gujarat" },
    { key: 287, label: "Savarkundla", value: "Savarkundla", state: "Gujarat" },
    { key: 288, label: "Jetpur", value: "Jetpur", state: "Gujarat" },
    { key: 289, label: "Wankaner", value: "Wankaner", state: "Gujarat" },
    { key: 290, label: "Mandvi", value: "Mandvi", state: "Gujarat" },
    { key: 291, label: "Dhoraji", value: "Dhoraji", state: "Gujarat" },
  { key: 292, label: "Kumuram Bheem Asifabad", value: "Kumuram Bheem Asifabad" },
  { key: 293, label: "Mancherial", value: "Mancherial" },
  { key: 294, label: "Hanumakonda", value: "Hanumakonda" },
  { key: 295, label: "Jagitial", value: "Jagitial" },
  { key: 296, label: "Rajanna Sircilla", value: "Rajanna Sircilla" },
  { key: 297, label: "Jangoan", value: "Jangoan" },
  { key: 298, label: "Siddipet", value: "Siddipet" },
  { key: 299, label: "Jayashankar Bhupalapally", value: "Jayashankar Bhupalapally" },
  { key: 300, label: "Karimnagar", value: "Karimnagar" },
  { key: 301, label: "Mulugu", value: "Mulugu" },
  { key: 302, label: "Medak", value: "Medak" },
  { key: 303, label: "Mahabubabad", value: "Mahabubabad" },
  { key: 304, label: "Kamareddy", value: "Kamareddy" },
  { key: 305, label: "Peddapalli", value: "Peddapalli" },
  { key: 306, label: "Sangareddy", value: "Sangareddy" },
  { key: 307, label: "Wanaparthy", value: "Wanaparthy" },
  { key: 308, label: "Jogulamba Gadwal", value: "Jogulamba Gadwal" },
  { key: 309, label: "Mahabubnagar", value: "Mahabubnagar" },
  { key: 310, label: "Narayanpet", value: "Narayanpet" },
  { key: 311, label: "Vikarabad", value: "Vikarabad" },
  { key: 312, label: "Yadadri Bhuvanagiri", value: "Yadadri Bhuvanagiri" },
  { key: 313, label: "Nalgonda", value: "Nalgonda" },
  { key: 314, label: "Suryapet", value: "Suryapet" },
  { key: 315, label: "Eluru", value: "Eluru" },
  { key: 316, label: "Anakapalli", value: "Anakapalli" },
  { key: 317, label: "Visakhapatanam", value: "Visakhapatanam" },
  { key: 318, label: "Alluri Sitharama Raju", value: "Alluri Sitharama Raju" },
  { key: 319, label: "East Godavari", value: "East Godavari" },
  { key: 320, label: "Parvathipuram Manyam", value: "Parvathipuram Manyam" },
  { key: 321, label: "Vizianagaram", value: "Vizianagaram" },
  { key: 322, label: "Srikakulam", value: "Srikakulam" },
  { key: 323, label: "Konaseema", value: "Konaseema" },
  { key: 324, label: "Dibrugarh", value: "Dibrugarh" },
  { key: 325, label: "Lakhimpur", value: "Lakhimpur" },
  { key: 326, label: "Dhemaji", value: "Dhemaji" },
  { key: 327, label: "West Karbi Anglong", value: "West Karbi Anglong" },
  { key: 328, label: "Karbi Anglong", value: "Karbi Anglong" },
  { key: 329, label: "Hojai", value: "Hojai" },
  { key: 330, label: "Nagaon", value: "Nagaon" },
  { key: 331, label: "Marigaon", value: "Marigaon" },
  { key: 332, label: "Kamrup Metro", value: "Kamrup Metro" },
  { key: 333, label: "Bhadradri Kothagudem", value: "Bhadradri Kothagudem" },
  { key: 334, label: "Khammam", value: "Khammam" },
  { key: 335, label: "Krishna", value: "Krishna" },
  { key: 336, label: "Prakasam", value: "Prakasam" },
  { key: 337, label: "Palnadu", value: "Palnadu" },
  { key: 338, label: "Spsr Nellore", value: "Spsr Nellore" },
  { key: 339, label: "Bapatla", value: "Bapatla" },
  { key: 340, label: "West Godavari", value: "West Godavari" },
  { key: 341, label: "Ntr", value: "Ntr" },
  { key: 342, label: "Jehanabad", value: "Jehanabad" },
  { key: 343, label: "Arwal", value: "Arwal" },
  { key: 344, label: "Jamui", value: "Jamui" },
  { key: 345, label: "Sheikhpura", value: "Sheikhpura" },
  { key: 346, label: "Lakhisarai", value: "Lakhisarai" },
  { key: 347, label: "Munger", value: "Munger" },
  { key: 348, label: "Nalanda", value: "Nalanda" },
  { key: 349, label: "Nawada", value: "Nawada" },
  { key: 350, label: "Rohtas", value: "Rohtas" },
  { key: 351, label: "Kaimur (bhabua)", value: "Kaimur (bhabua)" },
  { key: 352, label: "Vaishali", value: "Vaishali" },
  { key: 353, label: "Samastipur", value: "Samastipur" },
  { key: 354, label: "Dantewada", value: "Dantewada" },
  { key: 355, label: "Kondagaon", value: "Kondagaon" },
  { key: 356, label: "Sukma", value: "Sukma" },
  { key: 357, label: "Y.S.R.", value: "Y.S.R." },
  { key: 358, label: "Annamayya", value: "Annamayya" },
  { key: 359, label: "Sonitpur", value: "Sonitpur" },
  { key: 360, label: "Begusarai", value: "Begusarai" },
  { key: 361, label: "Khagaria", value: "Khagaria" },
  { key: 362, label: "Darbhanga", value: "Darbhanga" },
  { key: 363, label: "Madhubani", value: "Madhubani" },
  { key: 364, label: "Purbi Champaran", value: "Purbi Champaran" },
  { key: 365, label: "Sheohar", value: "Sheohar" },
  { key: 366, label: "Sitamarhi", value: "Sitamarhi" },
  { key: 367, label: "Katihar", value: "Katihar" },
  { key: 368, label: "Kishanganj", value: "Kishanganj" },
  { key: 369, label: "Araria", value: "Araria" },
  { key: 370, label: "Purnia", value: "Purnia" },
  { key: 371, label: "Saharsa", value: "Saharsa" },
  { key: 372, label: "Madhepura", value: "Madhepura" },
  { key: 373, label: "Saran", value: "Saran" },
  { key: 374, label: "Gopalganj", value: "Gopalganj" },
  { key: 375, label: "Siwan", value: "Siwan" },
  { key: 376, label: "Pashchim Champaran", value: "Pashchim Champaran" },
  { key: 377, label: "Banka", value: "Banka" },
  { key: 378, label: "Bhagalpur", value: "Bhagalpur" },
  { key: 379, label: "Bhojpur", value: "Bhojpur" },
  { key: 380, label: "Buxar", value: "Buxar" },
  { key: 381, label: "Ranga Reddy", value: "Ranga Reddy" },
  { key: 382, label: "Nagarkurnool", value: "Nagarkurnool" },
  { key: 383, label: "Medchal Malkajgiri", value: "Medchal Malkajgiri" },
  { key: 384, label: "Anantapur", value: "Anantapur" },
  { key: 385, label: "Sri Sathya Sai", value: "Sri Sathya Sai" },
  { key: 386, label: "Golaghat", value: "Golaghat" },
  { key: 387, label: "Jorhat", value: "Jorhat" },
  { key: 388, label: "Majuli", value: "Majuli" },
  { key: 389, label: "Sivasagar", value: "Sivasagar" },
  { key: 390, label: "Charaideo", value: "Charaideo" },
  { key: 391, label: "Tinsukia", value: "Tinsukia" },
  { key: 392, label: "Dhubri", value: "Dhubri" },
  { key: 393, label: "Chirang", value: "Chirang" },
  { key: 394, label: "Goalpara", value: "Goalpara" },
  { key: 395, label: "South Salmara Mancachar", value: "South Salmara Mancachar" },
  { key: 396, label: "Kokrajhar", value: "Kokrajhar" },
  { key: 397, label: "Kamrup", value: "Kamrup" },
  { key: 398, label: "Baksa", value: "Baksa" },
  { key: 399, label: "Ri Bhoi", value: "Ri Bhoi" },
  { key: 400, label: "Bajali", value: "Bajali" },
  { key: 401, label: "Barpeta", value: "Barpeta" },
  { key: 402, label: "Nalbari", value: "Nalbari" },
  { key: 403, label: "Karimganj", value: "Karimganj" },
  { key: 404, label: "Cachar", value: "Cachar" },
  { key: 405, label: "Hailakandi", value: "Hailakandi" },
  { key: 406, label: "Dima Hasao", value: "Dima Hasao" },
  { key: 407, label: "Darrang", value: "Darrang" },
  { key: 408, label: "Udalguri", value: "Udalguri" },
  { key: 409, label: "Biswanath", value: "Biswanath" },
  { key: 410, label: "Nirmal", value: "Nirmal" },
  { key: 411, label: "Adilabad", value: "Adilabad" },
  { key: 412, label: "Giridih", value: "Giridih" },
  { key: 413, label: "Hazaribagh", value: "Hazaribagh" },
  { key: 414, label: "Chatra", value: "Chatra" },
  { key: 415, label: "Koderma", value: "Koderma" },
  { key: 416, label: "Bokaro", value: "Bokaro" },
  { key: 417, label: "Ramgarh", value: "Ramgarh" },
  { key: 418, label: "Latehar", value: "Latehar" },
  { key: 419, label: "Garhwa", value: "Garhwa" },
  { key: 420, label: "Palamu", value: "Palamu" },
  { key: 421, label: "Khunti", value: "Khunti" },
  { key: 422, label: "Gumla", value: "Gumla" },
  { key: 423, label: "West Singhbhum", value: "West Singhbhum" },
  { key: 424, label: "Simdega", value: "Simdega" },
  { key: 425, label: "Lohardaga", value: "Lohardaga" },
  { key: 426, label: "Godda", value: "Godda" },
  { key: 427, label: "Deoghar", value: "Deoghar" },
  { key: 428, label: "Dumka", value: "Dumka" },
  { key: 429, label: "Jamtara", value: "Jamtara" },
  { key: 430, label: "Pakur", value: "Pakur" },
  { key: 431, label: "Sahebganj", value: "Sahebganj" },
  { key: 432, label: "Saraikela Kharsawan", value: "Saraikela Kharsawan" },
  { key: 433, label: "East Singhbum", value: "East Singhbum" },
  { key: 434, label: "Bengaluru Rural", value: "Bengaluru Rural" },
  { key: 435, label: "Bengaluru Urban", value: "Bengaluru Urban" },
  { key: 436, label: "Ramanagara", value: "Ramanagara" },
  { key: 437, label: "Bagalkot", value: "Bagalkot" },
  { key: 438, label: "Belagavi", value: "Belagavi" },
  { key: 439, label: "Ballari", value: "Ballari" },
  { key: 440, label: "Vijaynagar", value: "Vijaynagar" },
  { key: 441, label: "Vijayapura", value: "Vijayapura" },
  { key: 442, label: "Dharwad", value: "Dharwad" },
  { key: 443, label: "Gadag", value: "Gadag" },
  { key: 444, label: "Koppal", value: "Koppal" },
  { key: 445, label: "Kalaburagi", value: "Kalaburagi" },
  { key: 446, label: "Bastar", value: "Bastar" },
  { key: 447, label: "Kanker", value: "Kanker" },
  { key: 448, label: "Narayanpur", value: "Narayanpur" },
  { key: 449, label: "Janjgir-Champa", value: "Janjgir-Champa" },
  { key: 450, label: "Mungeli", value: "Mungeli" },
  { key: 451, label: "Rajnandgaon", value: "Rajnandgaon" },
  { key: 452, label: "Gaurella Pendra Marwahi", value: "Gaurella Pendra Marwahi" },
  { key: 453, label: "Durg", value: "Durg" },
  { key: 454, label: "Balod", value: "Balod" },
  { key: 455, label: "Bemetara", value: "Bemetara" },
  { key: 456, label: "Kabirdham", value: "Kabirdham" },
  { key: 457, label: "Korea", value: "Korea" },
  { key: 458, label: "Balrampur", value: "Balrampur" },
  { key: 459, label: "Surguja", value: "Surguja" },
  { key: 460, label: "Surajpur", value: "Surajpur" },
  { key: 461, label: "Raigarh", value: "Raigarh" },
  { key: 462, label: "Jashpur", value: "Jashpur" },
  { key: 463, label: "Mandi", value: "Mandi" },
  { key: 464, label: "Kullu", value: "Kullu" },
  { key: 465, label: "Kinnaur", value: "Kinnaur" },
  { key: 466, label: "Lahul And Spiti", value: "Lahul And Spiti" },
  { key: 467, label: "Sirmaur", value: "Sirmaur" },
  { key: 468, label: "Solan", value: "Solan" },
  { key: 469, label: "Una", value: "Una" },
  { key: 470, label: "Kangra", value: "Kangra" },
  { key: 471, label: "Baramulla", value: "Baramulla" },
  { key: 472, label: "Bandipora", value: "Bandipora" },
  { key: 473, label: "Kupwara", value: "Kupwara" },
  { key: 474, label: "Samba", value: "Samba" },
  { key: 475, label: "Udhampur", value: "Udhampur" },
  { key: 476, label: "Kathua", value: "Kathua" },
  { key: 477, label: "Leh Ladakh", value: "Leh Ladakh" },
  { key: 478, label: "Kargil", value: "Kargil" },
  { key: 479, label: "Rajouri", value: "Rajouri" },
  { key: 480, label: "Poonch", value: "Poonch" },
  { key: 481, label: "Anantnag", value: "Anantnag" },
  { key: 482, label: "Pulwama", value: "Pulwama" },
  { key: 483, label: "Shopian", value: "Shopian" },
  { key: 484, label: "Kulgam", value: "Kulgam" },
  { key: 485, label: "Budgam", value: "Budgam" },
  { key: 486, label: "Ganderbal", value: "Ganderbal" },
  { key: 487, label: "Reasi", value: "Reasi" },
  { key: 488, label: "Ramban", value: "Ramban" },
  { key: 489, label: "Doda", value: "Doda" },
  { key: 490, label: "Kishtwar", value: "Kishtwar" },
  { key: 491, label: "Devbhumi Dwarka", value: "Devbhumi Dwarka" },
  { key: 492, label: "Gir Somnath", value: "Gir Somnath" },
  { key: 493, label: "Kachchh", value: "Kachchh" },
  { key: 494, label: "Mahisagar", value: "Mahisagar" },
  { key: 495, label: "Kheda", value: "Kheda" },
  { key: 496, label: "Dang", value: "Dang" },
  { key: 497, label: "Tapi", value: "Tapi" },
  { key: 498, label: "Narmada", value: "Narmada" },
  { key: 499, label: "Yadgir", value: "Yadgir" },
  { key: 500, label: "Haveri", value: "Haveri" },
  { key: 501, label: "Davangere", value: "Davangere" },
  { key: 502, label: "Uttara Kannada", value: "Uttara Kannada" },
  { key: 503, label: "Chikkamagaluru", value: "Chikkamagaluru" },
  { key: 504, label: "Chitradurga", value: "Chitradurga" },
  { key: 505, label: "Hassan", value: "Hassan" },
  { key: 506, label: "Kodagu", value: "Kodagu" },
  { key: 507, label: "Chikkaballapura", value: "Chikkaballapura" },
  { key: 508, label: "Kolar", value: "Kolar" },
  { key: 509, label: "Mandya", value: "Mandya" },
  { key: 510, label: "Dohad", value: "Dohad" },
  { key: 511, label: "Panch Mahals", value: "Panch Mahals" },
  { key: 512, label: "Chhotaudepur", value: "Chhotaudepur" },
  { key: 513, label: "Daman", value: "Daman" },
  { key: 514, label: "Dadra And Nagar Haveli", value: "Dadra And Nagar Haveli" },
  { key: 515, label: "Yamunanagar", value: "Yamunanagar" },
  { key: 516, label: "Charki Dadri", value: "Charki Dadri" },
  { key: 517, label: "Palwal", value: "Palwal" },
  { key: 518, label: "Mahasamund", value: "Mahasamund" },
  { key: 519, label: "Baloda Bazar", value: "Baloda Bazar" },
  { key: 520, label: "Dhamtari", value: "Dhamtari" },
  { key: 521, label: "Gariyaband", value: "Gariyaband" },
  { key: 522, label: "North East", value: "North East" },
  { key: 523, label: "North", value: "North" },
  { key: 524, label: "North West", value: "North West" },
  { key: 525, label: "South", value: "South" },
  { key: 526, label: "West", value: "West" },
  { key: 527, label: "South West", value: "South West" },
  { key: 528, label: "Ahmadabad", value: "Ahmadabad" },
  { key: 529, label: "Banas Kantha", value: "Banas Kantha" },
  { key: 530, label: "Mahesana", value: "Mahesana" },
  { key: 531, label: "Sabar Kantha", value: "Sabar Kantha" },
  { key: 532, label: "Arvalli", value: "Arvalli" },
  { key: 533, label: "Nuh", value: "Nuh" },
  { key: 534, label: "Rewari", value: "Rewari" },
  { key: 535, label: "Mahendragarh", value: "Mahendragarh" },
  { key: 536, label: "Fatehabad", value: "Fatehabad" },
  { key: 537, label: "Hisar", value: "Hisar" },
  { key: 538, label: "Sirsa", value: "Sirsa" },
  { key: 539, label: "Jind", value: "Jind" },
  { key: 540, label: "Karnal", value: "Karnal" },
  { key: 541, label: "Kurukshetra", value: "Kurukshetra" },
  { key: 542, label: "Kaithal", value: "Kaithal" },
  { key: 543, label: "Jhajjar", value: "Jhajjar" },
  { key: 544, label: "Sonipat", value: "Sonipat" },
  { key: 545, label: "Chamba", value: "Chamba" },
  { key: 546, label: "Hamirpur", value: "Hamirpur" },
  { key: 547, label: "Ratnagiri", value: "Ratnagiri" },
  { key: 548, label: "Sindhudurg", value: "Sindhudurg" },
  { key: 549, label: "Raigad", value: "Raigad" },
  { key: 550, label: "Palghar", value: "Palghar" },
  { key: 551, label: "Washim", value: "Washim" },
  { key: 552, label: "Wardha", value: "Wardha" },
  { key: 553, label: "Chandrapur", value: "Chandrapur" },
  { key: 554, label: "Buldhana", value: "Buldhana" },
  { key: 555, label: "Gadchiroli", value: "Gadchiroli" },
  { key: 556, label: "Dakshina Kannada", value: "Dakshina Kannada" },
  { key: 557, label: "Chamarajanagara", value: "Chamarajanagara" },
  { key: 558, label: "Udupi", value: "Udupi" },
  { key: 559, label: "Alappuzha", value: "Alappuzha" },
  { key: 560, label: "Ernakulam", value: "Ernakulam" },
  { key: 561, label: "Kottayam", value: "Kottayam" },
  { key: 562, label: "Idukki", value: "Idukki" },
  { key: 563, label: "Pathanamthitta", value: "Pathanamthitta" },
  { key: 564, label: "Thrissur", value: "Thrissur" },
  { key: 565, label: "Latur", value: "Latur" },
  { key: 566, label: "Osmanabad", value: "Osmanabad" },
  { key: 567, label: "Hingoli", value: "Hingoli" },
  { key: 568, label: "Jalna", value: "Jalna" },
  { key: 569, label: "Kangpokpi", value: "Kangpokpi" },
  { key: 570, label: "Chandel", value: "Chandel" },
  { key: 571, label: "Pherzawl", value: "Pherzawl" },
  { key: 572, label: "Churachandpur", value: "Churachandpur" },
  { key: 573, label: "Imphal West", value: "Imphal West" },
  { key: 574, label: "Jiribam", value: "Jiribam" },
  { key: 575, label: "Thoubal", value: "Thoubal" },
  { key: 576, label: "Senapati", value: "Senapati" },
  { key: 577, label: "Imphal East", value: "Imphal East" },
  { key: 578, label: "Kamjong", value: "Kamjong" },
  { key: 579, label: "Ukhrul", value: "Ukhrul" },
  { key: 580, label: "Kakching", value: "Kakching" },
  { key: 581, label: "Bishnupur", value: "Bishnupur" },
  { key: 582, label: "Tengnoupal", value: "Tengnoupal" },
  { key: 583, label: "Noney", value: "Noney" },
  { key: 584, label: "Tamenglong", value: "Tamenglong" },
  { key: 585, label: "Aizawl", value: "Aizawl" },
  { key: 586, label: "Kolasib", value: "Kolasib" },
  { key: 587, label: "Lunglei", value: "Lunglei" },
  { key: 588, label: "Champhai", value: "Champhai" },
  { key: 589, label: "Hnahthial", value: "Hnahthial" },
  { key: 590, label: "Khawzawl", value: "Khawzawl" },
  { key: 591, label: "Lawngtlai", value: "Lawngtlai" },
  { key: 592, label: "Saitual", value: "Saitual" },
  { key: 593, label: "Mamit", value: "Mamit" },
  { key: 594, label: "Saiha", value: "Saiha" },
  { key: 595, label: "Serchhip", value: "Serchhip" },
  { key: 596, label: "Zunheboto", value: "Zunheboto" },
  { key: 597, label: "Dimapur", value: "Dimapur" },
  { key: 598, label: "Wokha", value: "Wokha" },
  { key: 599, label: "Mon", value: "Mon" },
  { key: 600, label: "Phek", value: "Phek" },
  { key: 601, label: "Mokokchung", value: "Mokokchung" },
  { key: 602, label: "Peren", value: "Peren" },
  { key: 603, label: "Kiphire", value: "Kiphire" },
  { key: 604, label: "Kohima", value: "Kohima" },
  { key: 605, label: "Wayanad", value: "Wayanad" },
  { key: 606, label: "Kannur", value: "Kannur" },
  { key: 607, label: "Kasaragod", value: "Kasaragod" },
  { key: 608, label: "Malappuram", value: "Malappuram" },
  { key: 609, label: "Mahe", value: "Mahe" },
  { key: 610, label: "Balaghat", value: "Balaghat" },
  { key: 611, label: "Mandla", value: "Mandla" },
  { key: 612, label: "Dindori", value: "Dindori" },
  { key: 613, label: "Seoni", value: "Seoni" },
  { key: 614, label: "Neemuch", value: "Neemuch" },
  { key: 615, label: "Raisen", value: "Raisen" },
  { key: 616, label: "Chhatarpur", value: "Chhatarpur" },
  { key: 617, label: "Panna", value: "Panna" },
  { key: 618, label: "Tikamgarh", value: "Tikamgarh" },
  { key: 619, label: "Niwari", value: "Niwari" },
  { key: 620, label: "Betul", value: "Betul" },
  { key: 621, label: "Chhindwara", value: "Chhindwara" },
  { key: 622, label: "Hoshangabad", value: "Hoshangabad" },
  { key: 623, label: "Harda", value: "Harda" },
  { key: 624, label: "Narsinghpur", value: "Narsinghpur" },
  { key: 625, label: "Satna", value: "Satna" },
  { key: 626, label: "Damoh", value: "Damoh" },
  { key: 627, label: "Katni", value: "Katni" },
  { key: 628, label: "Sagar", value: "Sagar" },
  { key: 629, label: "Shahdol", value: "Shahdol" },
  { key: 630, label: "Umaria", value: "Umaria" },
  { key: 631, label: "Anuppur", value: "Anuppur" },
  { key: 632, label: "Sidhi", value: "Sidhi" },
  { key: 633, label: "Singrauli", value: "Singrauli" },
  { key: 634, label: "Khargone", value: "Khargone" },
  { key: 635, label: "Vidisha", value: "Vidisha" },
  { key: 636, label: "Dhar", value: "Dhar" },
  { key: 637, label: "East Nimar", value: "East Nimar" },
  { key: 638, label: "Burhanpur", value: "Burhanpur" },
  { key: 639, label: "Barwani", value: "Barwani" },
  { key: 640, label: "Mandsaur", value: "Mandsaur" },
  { key: 641, label: "Jhabua", value: "Jhabua" },
  { key: 642, label: "Alirajpur", value: "Alirajpur" },
  { key: 643, label: "Ratlam", value: "Ratlam" },
  { key: 644, label: "Rajgarh", value: "Rajgarh" },
  { key: 645, label: "Bhandara", value: "Bhandara" },
  { key: 646, label: "Gondia", value: "Gondia" },
  { key: 647, label: "Yavatmal", value: "Yavatmal" },
  { key: 648, label: "Ahmednagar", value: "Ahmednagar" },
  { key: 649, label: "Jalgaon", value: "Jalgaon" },
  { key: 650, label: "Beed", value: "Beed" },
  { key: 651, label: "Nandurbar", value: "Nandurbar" },
  { key: 652, label: "Dhule", value: "Dhule" },
  { key: 653, label: "Sehore", value: "Sehore" },
  { key: 654, label: "Agar Malwa", value: "Agar Malwa" },
  { key: 655, label: "Shajapur", value: "Shajapur" },
  { key: 656, label: "Ashoknagar", value: "Ashoknagar" },
  { key: 657, label: "Guna", value: "Guna" },
  { key: 658, label: "Shivpuri", value: "Shivpuri" },
  { key: 659, label: "Datia", value: "Datia" },
  { key: 660, label: "Bhind", value: "Bhind" },
  { key: 661, label: "Morena", value: "Morena" },
  { key: 662, label: "Sheopur", value: "Sheopur" },
  { key: 663, label: "South Goa", value: "South Goa" },
  { key: 664, label: "North Goa", value: "North Goa" },
  { key: 665, label: "Fazilka", value: "Fazilka" },
  { key: 666, label: "Moga", value: "Moga" },
  { key: 667, label: "Firozepur", value: "Firozepur" },
  { key: 668, label: "Gurdaspur", value: "Gurdaspur" },
  { key: 669, label: "Pathankot", value: "Pathankot" },
  { key: 670, label: "Hoshiarpur", value: "Hoshiarpur" },
  { key: 671, label: "Shahid Bhagat Singh Nagar", value: "Shahid Bhagat Singh Nagar" },
  { key: 672, label: "Kapurthala", value: "Kapurthala" },
  { key: 673, label: "Rajsamand", value: "Rajsamand" },
  { key: 674, label: "Bhilwara", value: "Bhilwara" },
  { key: 675, label: "Chittorgarh", value: "Chittorgarh" },
  { key: 676, label: "Pratapgarh", value: "Pratapgarh" },
  { key: 677, label: "Banswara", value: "Banswara" },
  { key: 678, label: "Dungarpur", value: "Dungarpur" },
  { key: 679, label: "Jhalawar", value: "Jhalawar" },
  { key: 680, label: "Baran", value: "Baran" },
  { key: 681, label: "Bundi", value: "Bundi" },
  { key: 682, label: "Tonk", value: "Tonk" },
  { key: 683, label: "Balangir", value: "Balangir" },
  { key: 684, label: "Sonepur", value: "Sonepur" },
  { key: 685, label: "Anugul", value: "Anugul" },
  { key: 686, label: "Dhenkanal", value: "Dhenkanal" },
  { key: 687, label: "Kendujhar", value: "Kendujhar" },
  { key: 688, label: "Jajapur", value: "Jajapur" },
  { key: 689, label: "Bargarh", value: "Bargarh" },
  { key: 690, label: "Jharsuguda", value: "Jharsuguda" },
  { key: 691, label: "Sundargarh", value: "Sundargarh" },
  { key: 692, label: "Deogarh", value: "Deogarh" },
  { key: 693, label: "Ganjam", value: "Ganjam" },
  { key: 694, label: "Gajapati", value: "Gajapati" },
  { key: 695, label: "Kalahandi", value: "Kalahandi" },
  { key: 696, label: "Nuapada", value: "Nuapada" },
  { key: 697, label: "Malkangiri", value: "Malkangiri" },
  { key: 698, label: "Nabarangpur", value: "Nabarangpur" },
  { key: 699, label: "Koraput", value: "Koraput" },
  { key: 700, label: "Tuensang", value: "Tuensang" },
  { key: 701, label: "Noklak", value: "Noklak" },
  { key: 702, label: "West Tripura", value: "West Tripura" },
  { key: 703, label: "Sepahijala", value: "Sepahijala" },
  { key: 704, label: "Gomati", value: "Gomati" },
  { key: 705, label: "South Tripura", value: "South Tripura" },
  { key: 706, label: "West Siang", value: "West Siang" },
  { key: 707, label: "Siang", value: "Siang" },
  { key: 708, label: "Dibang Valley", value: "Dibang Valley" },
  { key: 709, label: "Papum Pare", value: "Papum Pare" },
  { key: 710, label: "Leparada", value: "Leparada" },
  { key: 711, label: "West Kameng", value: "West Kameng" },
  { key: 712, label: "Changlang", value: "Changlang" },
  { key: 713, label: "Upper Subansiri", value: "Upper Subansiri" },
  { key: 714, label: "Tirap", value: "Tirap" },
  { key: 715, label: "Anjaw", value: "Anjaw" },
  { key: 716, label: "East Siang", value: "East Siang" },
  { key: 717, label: "Tawang", value: "Tawang" },
  { key: 718, label: "Lower Siang", value: "Lower Siang" },
  { key: 719, label: "Longding", value: "Longding" },
  { key: 720, label: "Shi Yomi", value: "Shi Yomi" },
  { key: 721, label: "Namsai", value: "Namsai" },
  { key: 722, label: "Kurung Kumey", value: "Kurung Kumey" },
  { key: 723, label: "Lower Subansiri", value: "Lower Subansiri" },
  { key: 724, label: "Lower Dibang Valley", value: "Lower Dibang Valley" },
  { key: 725, label: "Pakke Kessang", value: "Pakke Kessang" },
  { key: 726, label: "East Kameng", value: "East Kameng" },
  { key: 727, label: "Lohit", value: "Lohit" },
  { key: 728, label: "Upper Siang", value: "Upper Siang" },
  { key: 729, label: "Dhalai", value: "Dhalai" },
  { key: 730, label: "Unakoti", value: "Unakoti" },
  { key: 731, label: "North Tripura", value: "North Tripura" },
  { key: 732, label: "Khowai", value: "Khowai" },
  { key: 733, label: "East Khasi Hills", value: "East Khasi Hills" },
  { key: 734, label: "South West Khasi Hills", value: "South West Khasi Hills" },
  { key: 735, label: "West Jaintia Hills", value: "West Jaintia Hills" },
  { key: 736, label: "East Jaintia Hills", value: "East Jaintia Hills" },
  { key: 737, label: "West Khasi Hills", value: "West Khasi Hills" },
  { key: 738, label: "South West Garo Hills", value: "South West Garo Hills" },
  { key: 739, label: "South Garo Hills", value: "South Garo Hills" },
  { key: 740, label: "West Garo Hills", value: "West Garo Hills" },
  { key: 741, label: "North Garo Hills", value: "North Garo Hills" },
  { key: 742, label: "East Garo Hills", value: "East Garo Hills" },
  { key: 743, label: "Bhadrak", value: "Bhadrak" },
  { key: 744, label: "Baleshwar", value: "Baleshwar" },
  { key: 745, label: "Barmer", value: "Barmer" },
  { key: 746, label: "Churu", value: "Churu" },
  { key: 747, label: "Jhunjhunu", value: "Jhunjhunu" },
  { key: 748, label: "Jaisalmer", value: "Jaisalmer" },
  { key: 749, label: "Nagaur", value: "Nagaur" },
  { key: 750, label: "Pali", value: "Pali" },
  { key: 751, label: "Sirohi", value: "Sirohi" },
  { key: 752, label: "Jalore", value: "Jalore" },
  { key: 753, label: "Dharmapuri", value: "Dharmapuri" },
  { key: 754, label: "Krishnagiri", value: "Krishnagiri" },
  { key: 755, label: "Tiruppur", value: "Tiruppur" },
  { key: 756, label: "Namakkal", value: "Namakkal" },
  { key: 757, label: "Salem", value: "Salem" },
  { key: 758, label: "The Nilgiris", value: "The Nilgiris" },
  { key: 759, label: "Tirupathur", value: "Tirupathur" },
  { key: 760, label: "Tiruvannamalai", value: "Tiruvannamalai" },
  { key: 761, label: "Kanniyakumari", value: "Kanniyakumari" },
  { key: 762, label: "Mayurbhanj", value: "Mayurbhanj" },
  { key: 763, label: "Khordha", value: "Khordha" },
  { key: 764, label: "Jagatsinghapur", value: "Jagatsinghapur" },
  { key: 765, label: "Nayagarh", value: "Nayagarh" },
  { key: 766, label: "Rayagada", value: "Rayagada" },
  { key: 767, label: "Boudh", value: "Boudh" },
  { key: 768, label: "Kandhamal", value: "Kandhamal" },
  { key: 769, label: "S.A.S Nagar", value: "S.A.S Nagar" },
  { key: 770, label: "Rupnagar", value: "Rupnagar" },
  { key: 771, label: "Patiala", value: "Patiala" },
  { key: 772, label: "Fatehgarh Sahib", value: "Fatehgarh Sahib" },
  { key: 773, label: "Malerkotla", value: "Malerkotla" },
  { key: 774, label: "Sangrur", value: "Sangrur" },
  { key: 775, label: "Barnala", value: "Barnala" },
  { key: 776, label: "Tarn Taran", value: "Tarn Taran" },
  { key: 777, label: "Bathinda", value: "Bathinda" },
  { key: 778, label: "Mansa", value: "Mansa" },
  { key: 779, label: "Sri Muktsar Sahib", value: "Sri Muktsar Sahib" },
  { key: 780, label: "Faridkot", value: "Faridkot" },
  { key: 781, label: "Alwar", value: "Alwar" },
  { key: 782, label: "Dholpur", value: "Dholpur" },
  { key: 783, label: "Dausa", value: "Dausa" },
  { key: 784, label: "Sawai Madhopur", value: "Sawai Madhopur" },
  { key: 785, label: "Karauli", value: "Karauli" },
  { key: 786, label: "Hanumangarh", value: "Hanumangarh" },
  { key: 787, label: "Ganganagar", value: "Ganganagar" },
  { key: 788, label: "Ranipet", value: "Ranipet" },
  { key: 789, label: "Villupuram", value: "Villupuram" },
  { key: 790, label: "Chengalpattu", value: "Chengalpattu" },
  { key: 791, label: "Kanchipuram", value: "Kanchipuram" },
  { key: 792, label: "Thiruvallur", value: "Thiruvallur" },
  { key: 793, label: "Pondicherry", value: "Pondicherry" },
  { key: 794, label: "Cuddalore", value: "Cuddalore" },
  { key: 795, label: "Rae Bareli", value: "Rae Bareli" },
  { key: 796, label: "Amethi", value: "Amethi" },
  { key: 797, label: "Sitapur", value: "Sitapur" },
  { key: 798, label: "Sultanpur", value: "Sultanpur" },
  { key: 799, label: "Almora", value: "Almora" },
  { key: 800, label: "Bageshwar", value: "Bageshwar" },
  { key: 801, label: "Pithoragarh", value: "Pithoragarh" },
  { key: 802, label: "Chamoli", value: "Chamoli" },
  { key: 803, label: "Rudra Prayag", value: "Rudra Prayag" },
  { key: 804, label: "Tehri Garhwal", value: "Tehri Garhwal" },
  { key: 805, label: "Haridwar", value: "Haridwar" },
  { key: 806, label: "Nainital", value: "Nainital" },
  { key: 807, label: "Udam Singh Nagar", value: "Udam Singh Nagar" },
  { key: 808, label: "Pauri Garhwal", value: "Pauri Garhwal" },
  { key: 809, label: "Champawat", value: "Champawat" },
  { key: 810, label: "Uttar Kashi", value: "Uttar Kashi" },
  { key: 811, label: "24 Paraganas South", value: "24 Paraganas South" },
  { key: 812, label: "24 Paraganas North", value: "24 Paraganas North" },
  { key: 813, label: "Birbhum", value: "Birbhum" },
  { key: 814, label: "Murshidabad", value: "Murshidabad" },
  { key: 815, label: "Purba Bardhaman", value: "Purba Bardhaman" },
  { key: 816, label: "Maldah", value: "Maldah" },
  { key: 817, label: "Nadia", value: "Nadia" },
  { key: 818, label: "South Andamans", value: "South Andamans" },
  { key: 819, label: "Nicobars", value: "Nicobars" },
  { key: 820, label: "North And Middle Andaman", value: "North And Middle Andaman" },
  { key: 821, label: "Alipurduar", value: "Alipurduar" },
  { key: 822, label: "Coochbehar", value: "Coochbehar" },
  { key: 823, label: "Kalimpong", value: "Kalimpong" },
  { key: 824, label: "Darjeeling", value: "Darjeeling" },
  { key: 825, label: "Jalpaiguri", value: "Jalpaiguri" },
  { key: 826, label: "Ballia", value: "Ballia" },
  { key: 827, label: "Azamgarh", value: "Azamgarh" },
  { key: 828, label: "Fatehpur", value: "Fatehpur" },
  { key: 829, label: "Chandauli", value: "Chandauli" },
  { key: 830, label: "Siddharth Nagar", value: "Siddharth Nagar" },
  { key: 831, label: "Bhadohi", value: "Bhadohi" },
  { key: 832, label: "Pilibhit", value: "Pilibhit" },
  { key: 833, label: "Bijnor", value: "Bijnor" },
  { key: 834, label: "Budaun", value: "Budaun" },
  { key: 835, label: "Sambhal", value: "Sambhal" },
  { key: 836, label: "Hardoi", value: "Hardoi" },
  { key: 837, label: "Kheri", value: "Kheri" },
  { key: 838, label: "Baghpat", value: "Baghpat" },
  { key: 839, label: "Amroha", value: "Amroha" },
  { key: 840, label: "Rampur", value: "Rampur" },
  { key: 841, label: "Muzaffarnagar", value: "Muzaffarnagar" },
  { key: 842, label: "Shamli", value: "Shamli" },
  { key: 843, label: "Mau", value: "Mau" },
  { key: 844, label: "Bahraich", value: "Bahraich" },
  { key: 845, label: "Shravasti", value: "Shravasti" },
  { key: 846, label: "Sant Kabeer Nagar", value: "Sant Kabeer Nagar" },
  { key: 847, label: "Basti", value: "Basti" },
  { key: 848, label: "Deoria", value: "Deoria" },
  { key: 849, label: "Kushi Nagar", value: "Kushi Nagar" },
  { key: 850, label: "Gonda", value: "Gonda" },
  { key: 851, label: "Gorakhpur", value: "Gorakhpur" },
  { key: 852, label: "Maharajganj", value: "Maharajganj" },
  { key: 853, label: "North District", value: "North District" },
  { key: 854, label: "East District", value: "East District" },
  { key: 855, label: "West District", value: "West District" },
  { key: 856, label: "South District", value: "South District" },
  { key: 857, label: "Pakyong", value: "Pakyong" },
  { key: 858, label: "Dinajpur Dakshin", value: "Dinajpur Dakshin" },
  { key: 859, label: "Dinajpur Uttar", value: "Dinajpur Uttar" },
  { key: 860, label: "Paschim Bardhaman", value: "Paschim Bardhaman" },
  { key: 861, label: "Bankura", value: "Bankura" },
  { key: 862, label: "Medinipur East", value: "Medinipur East" },
  { key: 863, label: "Medinipur West", value: "Medinipur West" },
  { key: 864, label: "Hooghly", value: "Hooghly" },
  { key: 865, label: "Jhargram", value: "Jhargram" },
  { key: 866, label: "Banda", value: "Banda" },
  { key: 867, label: "Chitrakoot", value: "Chitrakoot" },
  { key: 868, label: "Mahoba", value: "Mahoba" },
  { key: 869, label: "Farrukhabad", value: "Farrukhabad" },
  { key: 870, label: "Kannauj", value: "Kannauj" },
  { key: 871, label: "Kanpur Nagar", value: "Kanpur Nagar" },
  { key: 872, label: "Kanpur Dehat", value: "Kanpur Dehat" },
  { key: 873, label: "Unnao", value: "Unnao" },
  { key: 874, label: "Barabanki", value: "Barabanki" },
  { key: 875, label: "Ambedkar Nagar", value: "Ambedkar Nagar" },
  { key: 876, label: "Ayodhya", value: "Ayodhya" },
  { key: 877, label: "Firozabad", value: "Firozabad" },
  { key: 878, label: "Gautam Buddha Nagar", value: "Gautam Buddha Nagar" },
  { key: 879, label: "Sivaganga", value: "Sivaganga" },
  { key: 880, label: "Tuticorin", value: "Tuticorin" },
  { key: 881, label: "Virudhunagar", value: "Virudhunagar" },
  { key: 882, label: "Tenkasi", value: "Tenkasi" },
  { key: 883, label: "Ramanathapuram", value: "Ramanathapuram" },
  { key: 884, label: "Theni", value: "Theni" },
  { key: 885, label: "Karur", value: "Karur" },
  { key: 886, label: "Pudukkottai", value: "Pudukkottai" },
  { key: 887, label: "Thanjavur", value: "Thanjavur" },
  { key: 888, label: "Thiruvarur", value: "Thiruvarur" },
  { key: 889, label: "Mayiladuthurai", value: "Mayiladuthurai" },
  { key: 890, label: "Nagapattinam", value: "Nagapattinam" },
  { key: 891, label: "Karaikal", value: "Karaikal" },
  { key: 892, label: "Auraiya", value: "Auraiya" },
  { key: 893, label: "Etawah", value: "Etawah" },
  { key: 894, label: "Lalitpur", value: "Lalitpur" },
  { key: 895, label: "Jalaun", value: "Jalaun" },
  { key: 896, label: "Mainpuri", value: "Mainpuri" },
  { key: 897, label: "Hathras", value: "Hathras" },
  { key: 898, label: "Kaushambi", value: "Kaushambi" },
  { key: 899, label: "Jaunpur", value: "Jaunpur" },
  { key: 900, label: "Ghazipur", value: "Ghazipur" },
  { key: 901, label: "Sonbhadra", value: "Sonbhadra" },
  { key: 902, label: "Perambalur", value: "Perambalur" },
  { key: 903, label: "Ariyalur", value: "Ariyalur" },
  { key: 904, label: "Kallakurichi", value: "Kallakurichi" },
  { key: 905, label: "Etah", value: "Etah" },
  { key: 906, label: "Bulandshahr", value: "Bulandshahr" },
  { key: 907, label: "Kasganj", value: "Kasganj" },
  { key: 908, label: "Lakshadweep District", value: "Lakshadweep District" },
  { key: 909, label: "Mumbai Suburban", value: "Mumbai Suburban" },
  { key: 910, label: "Longleng", value: "Longleng" },
  { key: 911, label: "Shahdara", value: "Shahdara" },
  { key: 912, label: "East", value: "East" },
  { key: 913, label: "Central", value: "Central" },
  { key: 914, label: "South East", value: "South East" },
  { key: 915, label: "Diu", value: "Diu" },
  { key: 916, label: "Purulia", value: "Purulia" },
  { key: 917, label: "Kra Daadi", value: "Kra Daadi" },
  { key: 918, label: "Soreng", value: "Soreng" },
  { key: 919, label: "Yanam", value: "Yanam" },
  { key: 920, label: "Kamle", value: "Kamle" },
  { key: 921, label: "Alipur", value: "Alipur" },
  { key: 922, label: "Badagaon", value: "Badagaon" },
  { key: 923, label: "Badgaon", value: "Badgaon" },
  { key: 924, label: "Bahadurpur", value: "Bahadurpur" },
  { key: 925, label: "Bara", value: "Bara" },
  { key: 926, label: "Bargaon", value: "Bargaon" },
  { key: 927, label: "Bari", value: "Bari" },
  { key: 928, label: "Basantpur", value: "Basantpur" },
  { key: 929, label: "Bela", value: "Bela" },
  { key: 930, label: "Bishanpur", value: "Bishanpur" },
  { key: 931, label: "Borda", value: "Borda" },
  { key: 932, label: "Borgaon", value: "Borgaon" },
  { key: 933, label: "Bori", value: "Bori" },
  { key: 934, label: "Chainpur", value: "Chainpur" },
  { key: 935, label: "Chandpur", value: "Chandpur" },
  { key: 936, label: "Chikhali", value: "Chikhali" },
  { key: 937, label: "Chincholi", value: "Chincholi" },
  { key: 938, label: "Daulatpur", value: "Daulatpur" },
  { key: 939, label: "Deogaon", value: "Deogaon" },
  { key: 940, label: "Deori", value: "Deori" },
  { key: 941, label: "Dhanora", value: "Dhanora" },
  { key: 942, label: "Dharampur", value: "Dharampur" },
  { key: 943, label: "Dongargaon", value: "Dongargaon" },
  { key: 944, label: "Ganeshpur", value: "Ganeshpur" },
  { key: 945, label: "Gangapur", value: "Gangapur" },
  { key: 946, label: "Gaura", value: "Gaura" },
  { key: 947, label: "Gopalpur", value: "Gopalpur" },
  { key: 948, label: "Gopinathpur", value: "Gopinathpur" },
  { key: 949, label: "Govindpur", value: "Govindpur" },
  { key: 950, label: "Hariharpur", value: "Hariharpur" },
  { key: 951, label: "Haripur", value: "Haripur" },
  { key: 952, label: "Hirapur", value: "Hirapur" },
  { key: 953, label: "Jagdishpur", value: "Jagdishpur" },
  { key: 954, label: "Jalalpur", value: "Jalalpur" },
  { key: 955, label: "Kalyanpur", value: "Kalyanpur" },
  { key: 956, label: "Kamalpur", value: "Kamalpur" },
  { key: 957, label: "Kanchanpur", value: "Kanchanpur" },
  { key: 958, label: "Khaira", value: "Khaira" },
  { key: 959, label: "Khajuri", value: "Khajuri" },
  { key: 960, label: "Khanapur", value: "Khanapur" },
  { key: 961, label: "Khanpur", value: "Khanpur" },
  { key: 962, label: "Kothapalli", value: "Kothapalli" },
  { key: 963, label: "Krishnapuram", value: "Krishnapuram" },
  { key: 964, label: "Lalpur", value: "Lalpur" },
  { key: 965, label: "Laxmipur", value: "Laxmipur" },
  { key: 966, label: "Lohara", value: "Lohara" },
  { key: 967, label: "Madanpur", value: "Madanpur" },
  { key: 968, label: "Madhopur", value: "Madhopur" },
  { key: 969, label: "Mangrul", value: "Mangrul" },
  { key: 970, label: "Manikpur", value: "Manikpur" },
  { key: 971, label: "Manpur", value: "Manpur" },
  { key: 972, label: "Mohanpur", value: "Mohanpur" },
  { key: 973, label: "Nandgaon", value: "Nandgaon" },
  { key: 974, label: "Navagam", value: "Navagam" },
  { key: 975, label: "Nayagaon", value: "Nayagaon" },
  { key: 976, label: "Nuagaon", value: "Nuagaon" },
  { key: 977, label: "Paharpur", value: "Paharpur" },
  { key: 978, label: "Pratappur", value: "Pratappur" },
  { key: 979, label: "Raghunathpur", value: "Raghunathpur" },
  { key: 980, label: "Rajapur", value: "Rajapur" },
  { key: 981, label: "Rajpur", value: "Rajpur" },
  { key: 982, label: "Rajpura", value: "Rajpura" },
  { key: 983, label: "Ramapuram", value: "Ramapuram" },
  { key: 984, label: "Ramnagar", value: "Ramnagar" },
  { key: 985, label: "Rampura", value: "Rampura" },
  { key: 986, label: "Ranipur", value: "Ranipur" },
  { key: 987, label: "Rasulpur", value: "Rasulpur" },
  { key: 988, label: "Ratanpur", value: "Ratanpur" },
  { key: 989, label: "Salempur", value: "Salempur" },
  { key: 990, label: "Shahpur", value: "Shahpur" },
  { key: 991, label: "Shankarpur", value: "Shankarpur" },
  { key: 992, label: "Sherpur", value: "Sherpur" },
  { key: 993, label: "Umari", value: "Umari" },
  { key: 994, label: "Venkatapur", value: "Venkatapur" },
  { key: 995, label: "Venkatapuram", value: "Venkatapuram" },
];
// export const stateOptions = [
//   {
//     key: 1,
//     label: "Andaman and Nicobar Islands",
//     value: "Andaman and Nicobar Islands",
//   },
//   {key: 2, label: "Andhra Pradesh", value: "Andhra Pradesh"},
//   {key: 3, label: "Arunachal Pradesh", value: "Arunachal Pradesh"},
//   {key: 4, label: "Assam", value: "Assam"},
//   {key: 5, label: "Bihar", value: "Bihar"},
//   {key: 6, label: "Chandigarh", value: "Chandigarh"},
//   {key: 7, label: "Chhattisgarh", value: "Chhattisgarh"},
//   {
//     key: 8,
//     label: "Dadra and Nagar Haveli and Daman and Diu",
//     value: "Dadra and Nagar Haveli and Daman and Diu",
//   },
//   {key: 9, label: "Delhi", value: "Delhi"},
//   {key: 10, label: "Goa", value: "Goa"},
//   {key: 11, label: "Gujarat", value: "Gujarat"},
//   {key: 12, label: "Haryana", value: "Haryana"},
//   {key: 13, label: "Himachal Pradesh", value: "Himachal Pradesh"},
//   {key: 14, label: "Hyderabad", value: "Hyderabad"},
//   {key: 15, label: "Jammu and Kashmir", value: "Jammu and Kashmir"},
//   {key: 16, label: "Jharkhand", value: "Jharkhand"},
//   {key: 17, label: "Karnataka", value: "Karnataka"},
//   {key: 18, label: "Kerala", value: "Kerala"},
//   {key: 19, label: "Ladakh", value: "Ladakh"},
//   {key: 20, label: "Lakshadweep", value: "Lakshadweep"},
//   {key: 21, label: "Madhya Pradesh", value: "Madhya Pradesh"},
//   {key: 22, label: "Maharashtra", value: "Maharashtra"},
//   {key: 23, label: "Manipur", value: "Manipur"},
//   {key: 24, label: "Meghalaya", value: "Meghalaya"},
//   {key: 25, label: "Mizoram", value: "Mizoram"},
//   {key: 26, label: "Nagaland", value: "Nagaland"},
//   {key: 27, label: "Odisha", value: "Odisha"},
//   {key: 28, label: "Puducherry", value: "Puducherry"},
//   {key: 29, label: "Punjab", value: "Punjab"},
//   {key: 30, label: "Rajasthan", value: "Rajasthan"},
//   {key: 31, label: "Sikkim", value: "Sikkim"},
//   {key: 32, label: "Tamil Nadu", value: "Tamil Nadu"},
//   {key: 33, label: "Telangana", value: "Telangana"},
//   {key: 34, label: "Tripura", value: "Tripura"},
//   {key: 35, label: "Uttar Pradesh", value: "Uttar Pradesh"},
//   {key: 36, label: "Uttarakhand", value: "Uttarakhand"},
//   {key: 37, label: "West Bengal", value: "West Bengal"},
// ];
export const stateOptions = [
  {
    key: 1,
    label: "Jammu and Kashmir",
    value: "Jammu and Kashmir",
  },
  {
    key: 2,
    label: "Himachal Pradesh",
    value: "Himachal Pradesh",
  },
  {
    key: 3,
    label: "Punjab",
    value: "Punjab",
  },
  {
    key: 4,
    label: "Chandigarh",
    value: "Chandigarh",
  },
  {
    key: 5,
    label: "Uttarakhand",
    value: "Uttarakhand",
  },
  {
    key: 6,
    label: "Haryana",
    value: "Haryana",
  },
  {
    key: 7,
    label: "Delhi",
    value: "Delhi",
  },
  {
    key: 8,
    label: "Rajasthan",
    value: "Rajasthan",
  },
  {
    key: 9,
    label: "Uttar Pradesh",
    value: "Uttar Pradesh",
  },
  {
    key: 10,
    label: "Bihar",
    value: "Bihar",
  },
  {
    key: 11,
    label: "Sikkim",
    value: "Sikkim",
  },
  {
    key: 12,
    label: "Arunachal Pradesh",
    value: "Arunachal Pradesh",
  },
  {
    key: 13,
    label: "Nagaland",
    value: "Nagaland",
  },
  {
    key: 14,
    label: "Manipur",
    value: "Manipur",
  },
  {
    key: 15,
    label: "Mizoram",
    value: "Mizoram",
  },
  {
    key: 16,
    label: "Tripura",
    value: "Tripura",
  },
  {
    key: 17,
    label: "Meghalaya",
    value: "Meghalaya",
  },
  {
    key: 18,
    label: "Assam",
    value: "Assam",
  },
  {
    key: 19,
    label: "West Bengal",
    value: "West Bengal",
  },
  {
    key: 20,
    label: "Jharkhand",
    value: "Jharkhand",
  },
  {
    key: 21,
    label: "Odisha",
    value: "Odisha",
  },
  {
    key: 22,
    label: "Chhattisgarh",
    value: "Chhattisgarh",
  },
  {
    key: 23,
    label: "Madhya Pradesh",
    value: "Madhya Pradesh",
  },
  {
    key: 24,
    label: "Gujarat",
    value: "Gujarat",
  },
  {
    key: 25,
    label: "Daman and Diu",
    value: "Daman and Diu",
  },
  {
    key: 26,
    label: "Dadra and Nagar Haveli",
    value: "Dadra and Nagar Haveli",
  },
  {
    key: 27,
    label: "Maharashtra",
    value: "Maharashtra",
  },
  // {
  //   key: 28,
  //   label: "Andhra Pradesh", // Removed from original list, but added back in
  //   value: "Andhra Pradesh",
  // },
  {
    key: 29,
    label: "Karnataka",
    value: "Karnataka",
  },
  {
    key: 30,
    label: "Goa",
    value: "Goa",
  },
  {
    key: 31,
    label: "Lakshadweep",
    value: "Lakshadweep",
  },
  {
    key: 32,
    label: "Kerala",
    value: "Kerala",
  },
  {
    key: 33,
    label: "Tamil Nadu",
    value: "Tamil Nadu",
  },
  {
    key: 34,
    label: "Puducherry",
    value: "Puducherry",
  },
  {
    key: 35,
    label: "Andaman and Nicobar",
    value: "Andaman and Nicobar",
  },
  {
    key: 36,
    label: "Telangana",
    value: "Telangana",
  },
  {
    key: 37,
    label: "Andhra Pradesh",
    value: "Andhra Pradesh",
 },
  {
    key: 38,
    label: "Ladakh",
    value: "Ladakh",
  },
];
export const dropDownData = {
  primary_material_type: [
    {key: "bamboo", label: "Bamboo", value: "Bamboo"},
    {key: "ceramic", label: "Ceramic", value: "Ceramic"},
    {key: "crystal", label: "Crystal", value: "Crystal"},
    {key: "faux_wood", label: "Faux Wood", value: "Faux Wood"},
    {key: "glass", label: "Glass", value: "Glass"},
    {key: "metal", label: "Metal", value: "Metal"},
    {key: "plastic", label: "Plastic", value: "Plastic"},
    {key: "resin", label: "Resin", value: "Resin"},
    {key: "wood", label: "Wood", value: "Wood"},
    {key: "abs", label: "ABS", value: "ABS"},
    {key: "aluminum", label: "Aluminum", value: "Aluminum"},
    {key: "aluminum_oxide", label: "Aluminum Oxide", value: "Aluminum Oxide"},
    {key: "antimony", label: "Antimony", value: "Antimony"},
    {key: "baking_soda", label: "Baking Soda", value: "Baking Soda"},
    {key: "bismuth", label: "Bismuth", value: "Bismuth"},
    {key: "black_oxide", label: "Black Oxide", value: "Black Oxide"},
    {key: "brass", label: "Brass", value: "Brass"},
    {key: "bronze", label: "Bronze", value: "Bronze"},
    {key: "butyl", label: "Butyl", value: "Butyl"},
    {key: "cpvc", label: "CPVC", value: "CPVC"},
    {key: "cadmium", label: "Cadmium", value: "Cadmium"},
    {key: "calcite", label: "Calcite", value: "Calcite"},
    {key: "carbide", label: "Carbide", value: "Carbide"},
    {key: "carbon_steel", label: "Carbon Steel", value: "Carbon Steel"},
    {
      key: "ceramic_iron_oxide",
      label: "Ceramic Iron Oxide",
      value: "Ceramic Iron Oxide",
    },
    {key: "cermet", label: "Cermet", value: "Cermet"},
    {key: "cerro_alloys", label: "Cerro Alloys", value: "Cerro Alloys"},
    {key: "chloroprene", label: "Chloroprene", value: "Chloroprene"},
    {
      key: "chlorosulfonated_polyethylene",
      label: "Chlorosulfonated Polyethylene (CSM)",
      value: "Chlorosulfonated Polyethylene (CSM)",
    },
    {key: "chromium", label: "Chromium", value: "Chromium"},
    {key: "chromium_oxide", label: "Chromium Oxide", value: "Chromium Oxide"},
    {key: "cobalt", label: "Cobalt", value: "Cobalt"},
    {key: "cobalt_steel", label: "Cobalt Steel", value: "Cobalt Steel"},
    {
      key: "cold_rolled_steel",
      label: "Cold Rolled Steel",
      value: "Cold Rolled Steel",
    },
    {key: "copper", label: "Copper", value: "Copper"},
    {key: "cordierite", label: "Cordierite", value: "Cordierite"},
    {key: "corn_cob", label: "Corn Cob", value: "Corn Cob"},
    {key: "corundum", label: "Corundum", value: "Corundum"},
    {key: "crocus", label: "Crocus", value: "Crocus"},
    {key: "crystal_1", label: "Crystal", value: "Crystal"},
    {
      key: "cubic_boron_nitride",
      label: "Cubic Boron Nitride",
      value: "Cubic Boron Nitride",
    },
    {
      key: "cubic_boron_nitride_cbn",
      label: "Cubic Boron Nitride (CBN)",
      value: "Cubic Boron Nitride (CBN)",
    },
    {key: "diamond", label: "Diamond", value: "Diamond"},
    {key: "elastomers", label: "Elastomers", value: "Elastomers"},
    {key: "emery", label: "Emery", value: "Emery"},
    {key: "fabric", label: "Fabric", value: "Fabric"},
    {key: "felt", label: "Felt", value: "Felt"},
    {key: "fiberglass", label: "Fiberglass", value: "Fiberglass"},
    {key: "fibralon", label: "Fibralon", value: "Fibralon"},
    {key: "foam", label: "Foam", value: "Foam"},
    {key: "forged", label: "Forged", value: "Forged"},
    {
      key: "galvanized_steel",
      label: "Galvanized Steel",
      value: "Galvanized Steel",
    },
    {key: "garnet", label: "Garnet", value: "Garnet"},
    {
      key: "glass_aluminum_oxide",
      label: "Glass-Aluminum Oxide",
      value: "Glass-Aluminum Oxide",
    },
    {key: "gold", label: "Gold", value: "Gold"},
    {key: "gold_ferroud", label: "Gold Ferroud", value: "Gold Ferroud"},
    {key: "graphite", label: "Graphite", value: "Graphite"},
    {key: "gum_rubber", label: "Gum Rubber", value: "Gum Rubber"},
    {key: "hastelloy", label: "Hastelloy", value: "Hastelloy"},
    {key: "heat_treated", label: "Heat-Treated", value: "Heat-Treated"},
    {
      key: "high_density_polyethylene",
      label: "High Density Polyethylene (HDPE)",
      value: "High Density Polyethylene (HDPE)",
    },
    {
      key: "high_speed_steel",
      label: "High Speed Steel (HSS)",
      value: "High Speed Steel (HSS)",
    },
    {
      key: "hot_rolled_steel",
      label: "Hot Rolled Steel",
      value: "Hot Rolled Steel",
    },
    {key: "hydex", label: "Hydex", value: "Hydex"},
    {
      key: "hydrogenated_nitrile_butadiene_rubber",
      label: "Hydrogenated Nitrile Butadiene Rubber (HNBR)",
      value: "Hydrogenated Nitrile Butadiene Rubber (HNBR)",
    },
    {key: "inconel", label: "Inconel", value: "Inconel"},
    {key: "iron", label: "Iron", value: "Iron"},
    {
      key: "iron_cast_iron",
      label: "Iron & Cast Iron",
      value: "Iron & Cast Iron",
    },
    {key: "iron_oxide", label: "Iron Oxide", value: "Iron Oxide"},
    {key: "kalrez", label: "Kalrez", value: "Kalrez"},
    {key: "kevlar", label: "Kevlar", value: "Kevlar"},
    {key: "kraft_paper", label: "Kraft Paper", value: "Kraft Paper"},
    {key: "latex", label: "Latex", value: "Latex"},
    {key: "lead", label: "Lead", value: "Lead"},
    {key: "leather", label: "Leather", value: "Leather"},
    {key: "lexon", label: "Lexon", value: "Lexon"},
    {
      key: "liquid_silicone_rubber",
      label: "Liquid Silicone Rubber",
      value: "Liquid Silicone Rubber",
    },
    {
      key: "low_density_polyethylene",
      label: "Low Density Polyethylene (LDPE)",
      value: "Low Density Polyethylene (LDPE)",
    },
    {key: "magnesium", label: "Magnesium", value: "Magnesium"},
    {
      key: "manganese_steel",
      label: "Manganese Steel",
      value: "Manganese Steel",
    },
    {key: "maraging_steel", label: "Maraging Steel", value: "Maraging Steel"},
    {key: "marble", label: "Marble", value: "Marble"},
    {key: "metal_1", label: "Metal", value: "Metal"},
    {key: "molded_epoxy", label: "Molded Epoxy", value: "Molded Epoxy"},
    {
      key: "molybdenum_steel",
      label: "Molybdenum Steel",
      value: "Molybdenum Steel",
    },
    {key: "mullite", label: "Mullite", value: "Mullite"},
    {key: "natural_rubber", label: "Natural Rubber", value: "Natural Rubber"},
    {key: "neoprene", label: "Neoprene", value: "Neoprene"},
    {key: "nickel", label: "Nickel", value: "Nickel"},
    {key: "nitinol", label: "Nitinol", value: "Nitinol"},
    {key: "nitrile_rubber", label: "Nitrile Rubber", value: "Nitrile Rubber"},
    {key: "novaculite", label: "Novaculite", value: "Novaculite"},
    {key: "nylon", label: "Nylon", value: "Nylon"},
    {key: "oak", label: "Oak", value: "Oak"},
    {key: "petg", label: "PETG", value: "PETG"},
    {key: "pex", label: "PEX", value: "PEX"},
    {key: "pvc", label: "PVC", value: "PVC"},
    {key: "paper", label: "Paper", value: "Paper"},
    {key: "pebax", label: "Pebax", value: "Pebax"},
    {
      key: "perfluoralkoxy",
      label: "Perfluoralkoxy (PFA)",
      value: "Perfluoralkoxy (PFA)",
    },
    {
      key: "perfluoroelastomer",
      label: "Perfluoroelastomer",
      value: "Perfluoroelastomer",
    },
    {key: "pewter", label: "Pewter", value: "Pewter"},
    {key: "phenolic", label: "Phenolic", value: "Phenolic"},
    {key: "pine", label: "Pine", value: "Pine"},
    {key: "plastic_1", label: "Plastic", value: "Plastic"},
    {key: "platinum", label: "Platinum", value: "Platinum"},
    {key: "polyacrylate", label: "Polyacrylate", value: "Polyacrylate"},
    {
      key: "polyamide_imide",
      label: "Polyamide Imide",
      value: "Polyamide Imide",
    },
    {
      key: "polybutylene_terephthalate",
      label: "Polybutylene Terephtalate (PBT)",
      value: "Polybutylene Terephtalate (PBT)",
    },
    {key: "polycarbonate", label: "Polycarbonate", value: "Polycarbonate"},
    {
      key: "polychloroprene",
      label: "Polychloroprene",
      value: "Polychloroprene",
    },
    {
      key: "polycrystalline_diamond",
      label: "Polycrystalline Diamond (PCD)",
      value: "Polycrystalline Diamond (PCD)",
    },
    {key: "polyester", label: "Polyester", value: "Polyester"},
    {
      key: "peek",
      label: "Polyetheretherketone (PEEK)",
      value: "Polyetheretherketone (PEEK)",
    },
    {key: "polyetherimide", label: "Polyetherimide", value: "Polyetherimide"},
    {
      key: "polyethersulfone",
      label: "Polyethersulfone",
      value: "Polyethersulfone",
    },
    {key: "polyethylene", label: "Polyethylene", value: "Polyethylene"},
    {key: "polyimide", label: "Polyimide", value: "Polyimide"},
    {key: "polymer", label: "Polymer", value: "Polymer"},
    {
      key: "polymethylpentane",
      label: "Polymethylpentane",
      value: "Polymethylpentane",
    },
    {key: "polyolefin", label: "Polyolefin", value: "Polyolefin"},
    {
      key: "delrin",
      label: "Polyoxymethylene (Delrin)",
      value: "Polyoxymethylene (Delrin)",
    },
    {
      key: "noryl_en265",
      label: "Polyphenylene Ether (NORYL EN-265)",
      value: "Polyphenylene Ether (NORYL EN-265)",
    },
    {
      key: "polyphenylene_oxide",
      label: "Polyphenylene Oxide",
      value: "Polyphenylene Oxide",
    },
    {
      key: "pps",
      label: "Polyphenylene Sulfide (PPS)",
      value: "Polyphenylene Sulfide (PPS)",
    },
    {key: "polypropylene", label: "Polypropylene", value: "Polypropylene"},
    {key: "polystyrene", label: "Polystyrene", value: "Polystyrene"},
    {key: "polysulfone", label: "Polysulfone", value: "Polysulfone"},
    {
      key: "fluorosint_500_ptfe",
      label: "Polytetrafluoroethylene (FLUOROSINT 500 PTFE)",
      value: "Polytetrafluoroethylene (FLUOROSINT 500 PTFE)",
    },
    {
      key: "ptfe",
      label: "Polytetrafluoroethylene (PTFE)",
      value: "Polytetrafluoroethylene (PTFE)",
    },
    {key: "polyurethane", label: "Polyurethane", value: "Polyurethane"},
    {
      key: "pva",
      label: "Polyvinyl Acetate (PVA)",
      value: "Polyvinyl Acetate (PVA)",
    },
    {
      key: "pvc_type_i",
      label: "Polyvinyl Chloride Type I",
      value: "Polyvinyl Chloride Type I",
    },
    {
      key: "pvc_type_ii",
      label: "Polyvinyl Chloride Type II",
      value: "Polyvinyl Chloride Type II",
    },
    {
      key: "pvdf",
      label: "Polyvinylidene Fluoride (PVDF)",
      value: "Polyvinylidene Fluoride (PVDF)",
    },
    {key: "porcelain", label: "Porcelain", value: "Porcelain"},
    {
      key: "powdered_metal_cobalt_steel",
      label: "Powdered Metal Cobalt Steel",
      value: "Powdered Metal Cobalt Steel",
    },
    {
      key: "powdered_metal_steel",
      label: "Powdered Metal Steel",
      value: "Powdered Metal Steel",
    },
    {key: "pumice", label: "Pumice", value: "Pumice"},
    {key: "quartz", label: "Quartz", value: "Quartz"},
    {key: "resin", label: "Resin", value: "Resin"},
    {key: "rhodium", label: "Rhodium", value: "Rhodium"},
    {key: "rosewood", label: "Rosewood", value: "Rosewood"},
    {key: "rubber", label: "Rubber", value: "Rubber"},
    {key: "ruby", label: "Ruby", value: "Ruby"},
    {key: "rulon_ar", label: "Rulon AR", value: "Rulon AR"},
    {key: "rulon_j", label: "Rulon J", value: "Rulon J"},
    {key: "rulon_lr", label: "Rulon LR", value: "Rulon LR"},
    {key: "sand", label: "Sand", value: "Sand"},
    {
      key: "silicon_carbide",
      label: "Silicon Carbide",
      value: "Silicon Carbide",
    },
    {
      key: "silicon_carbide_aluminum_oxide",
      label: "Silicon Carbide-Aluminum Oxide",
      value: "Silicon Carbide-Aluminum Oxide",
    },
    {
      key: "silicon_dioxide",
      label: "Silicon Dioxide (Silica)",
      value: "Silicon Dioxide (Silica)",
    },
    {
      key: "silicon_manganese_steel",
      label: "Silicon Manganese Steel",
      value: "Silicon Manganese Steel",
    },
    {
      key: "silicone_rubber",
      label: "Silicone Rubber",
      value: "Silicone Rubber",
    },
    {key: "sillimanite", label: "Sillimanite", value: "Sillimanite"},
    {key: "silver", label: "Silver", value: "Silver"},
    {key: "simriz", label: "Simriz", value: "Simriz"},
    {key: "spring_steel", label: "Spring Steel", value: "Spring Steel"},
    {
      key: "stainless_steel",
      label: "Stainless Steel",
      value: "Stainless Steel",
    },
    {key: "steatite", label: "Steatite", value: "Steatite"},
    {key: "steel", label: "Steel", value: "Steel"},
    {key: "steel_shot", label: "Steel Shot", value: "Steel Shot"},
    {key: "stone", label: "Stone", value: "Stone"},
    {
      key: "styrene_butadiene_rubber",
      label: "Styrene-butadiene Rubber",
      value: "Styrene-butadiene Rubber",
    },
    {
      key: "pmma",
      label: "Synthetic Polymer (PMMA)",
      value: "Synthetic Polymer (PMMA)",
    },
    {key: "synthetic_ruby", label: "Synthetic Ruby", value: "Synthetic Ruby"},
    {
      key: "synthetic_sapphire",
      label: "Synthetic Sapphire",
      value: "Synthetic Sapphire",
    },
    {key: "talc", label: "Talc", value: "Talc"},
    {key: "teak", label: "Teak", value: "Teak"},
    {
      key: "tetrafluoroethylene_hexafluoropropylene_vinylidene_fluoride",
      label: "Tetrafluoroethylene Hexafluoropropylene Vinylidene Fluoride",
      value: "Tetrafluoroethylene Hexafluoropropylene Vinylidene Fluoride",
    },
    {key: "thin_film", label: "Thin Film", value: "Thin Film"},
    {key: "tin", label: "Tin", value: "Tin"},
    {key: "titanium", label: "Titanium", value: "Titanium"},
    {key: "tool_steel", label: "Tool Steel", value: "Tool Steel"},
    {key: "torlon_4203", label: "Torlon 4203", value: "Torlon 4203"},
    {key: "torlon_4301", label: "Torlon 4301", value: "Torlon 4301"},
    {key: "tungsten", label: "Tungsten", value: "Tungsten"},
    {key: "turcite", label: "Turcite", value: "Turcite"},
    {
      key: "uhmw",
      label: "UHMW (Ultra High Molecular Weight)",
      value: "UHMW (Ultra High Molecular Weight)",
    },
    {key: "urethane", label: "Urethane", value: "Urethane"},
    {key: "viton", label: "Viton", value: "Viton"},
    {key: "viton_extreme", label: "Viton Extreme", value: "Viton Extreme"},
    {key: "walnut", label: "Walnut", value: "Walnut"},
    {key: "walnut_shell", label: "Walnut Shell", value: "Walnut Shell"},
    {
      key: "white_high_impact_styrene",
      label: "White High-impact Styrene",
      value: "White High-impact Styrene",
    },
    {key: "willow", label: "Willow", value: "Willow"},
    {key: "wire_wound", label: "Wire Wound", value: "Wire Wound"},
    {key: "wood", label: "Wood", value: "Wood"},
    {key: "wood_laminate", label: "Wood Laminate", value: "Wood Laminate"},
    {key: "wool", label: "Wool", value: "Wool"},
    {key: "zinc", label: "Zinc", value: "Zinc"},
    {key: "zirconia", label: "Zirconia", value: "Zirconia"},
    {
      key: "zirconia_alumina",
      label: "Zirconia Alumina",
      value: "Zirconia Alumina",
    },
    {
      key: "zirconia_alumina_aluminum_oxide",
      label: "Zirconia Alumina-Aluminum Oxide",
      value: "Zirconia Alumina-Aluminum Oxide",
    },
    {
      key: "zirconia_alumina_silicon_carbide",
      label: "Zirconia Alumina-Silicon Carbide",
      value: "Zirconia Alumina-Silicon Carbide",
    },
    {
      key: "zirkon_aluminum",
      label: "Zirkon Aluminum",
      value: "Zirkon Aluminum",
    },
  ],
  finish_type: [
    {key: "Finished", label: "Finished", value: "Finished"},
    {key: "Glossy", label: "Glossy", value: "Glossy"},
    {key: "Hand-Scraped", label: "Hand-Scraped", value: "Hand-Scraped"},
    {
      key: "High Speed Steel",
      label: "High Speed Steel",
      value: "High Speed Steel",
    },
    {key: "Matte", label: "Matte", value: "Matte"},
    {key: "Polished", label: "Polished", value: "Polished"},
    {
      key: "Stainless-Steel",
      label: "Stainless-Steel",
      value: "Stainless-Steel",
    },
    {key: "Tialn", label: "Tialn", value: "Tialn"},
    {key: "TiCN", label: "TiCN", value: "TiCN"},
    {key: "Uncoated", label: "Uncoated", value: "Uncoated"},
    {key: "Zinc Plated", label: "Zinc Plated", value: "Zinc Plated"},
    {key: "Cast", label: "Cast", value: "Cast"},
    {key: "Coated", label: "Coated", value: "Coated"},
    {key: "Antique", label: "Antique", value: "Antique"},
    {key: "Biscuit", label: "Biscuit", value: "Biscuit"},
    {key: "Brass", label: "Brass", value: "Brass"},
    {key: "Unfinished", label: "Unfinished", value: "Unfinished"},
    {key: "Iron", label: "Iron", value: "Iron"},
    {key: "Machined", label: "Machined", value: "Machined"},
    {key: "Cobalt", label: "Cobalt", value: "Cobalt"},
    {key: "Silk", label: "Silk", value: "Silk"},
    {key: "Satin", label: "Satin", value: "Satin"},
    {key: "Pewter", label: "Pewter", value: "Pewter"},
    {key: "TiN", label: "TiN", value: "TiN"},
    {key: "Chrome", label: "Chrome", value: "Chrome"},
    {key: "Limewash", label: "Limewash", value: "Limewash"},
    {
      key: "Tungsten Carbide",
      label: "Tungsten Carbide",
      value: "Tungsten Carbide",
    },
    {key: "Copper", label: "Copper", value: "Copper"},
    {key: "Stainless", label: "Stainless", value: "Stainless"},
    {key: "Venetian", label: "Venetian", value: "Venetian"},
    {key: "Bronze", label: "Bronze", value: "Bronze"},
    {key: "Brushed Bronze", label: "Brushed Bronze", value: "Brushed Bronze"},
    {key: "Gold", label: "Gold", value: "Gold"},
    {key: "TiB2", label: "TiB2", value: "TiB2"},
    {key: "Multiple", label: "Multiple", value: "Multiple"},
    {key: "Stamped", label: "Stamped", value: "Stamped"},
    {key: "Brushed Nickel", label: "Brushed Nickel", value: "Brushed Nickel"},
    {key: "AlTiN", label: "AlTiN", value: "AlTiN"},
    {key: "Brushed Chrome", label: "Brushed Chrome", value: "Brushed Chrome"},
    {key: "Masonry", label: "Masonry", value: "Masonry"},
    {key: "Steel", label: "Steel", value: "Steel"},
    {key: "Eggshell", label: "Eggshell", value: "Eggshell"},
    {key: "Silver", label: "Silver", value: "Silver"},
    {key: "TiSiN", label: "TiSiN", value: "TiSiN"},
    {key: "Metallic", label: "Metallic", value: "Metallic"},
    {key: "Mixed", label: "Mixed", value: "Mixed"},
    {key: "Ceramic", label: "Ceramic", value: "Ceramic"},
    {key: "Nickel", label: "Nickel", value: "Nickel"},
    {key: "Brushed Brass", label: "Brushed Brass", value: "Brushed Brass"},
    {key: "Brushed Steel", label: "Brushed Steel", value: "Brushed Steel"},
    {key: "Painted", label: "Painted", value: "Painted"},
    {key: "Polished Brass", label: "Polished Brass", value: "Polished Brass"},
    {
      key: "Polished Chrome",
      label: "Polished Chrome",
      value: "Polished Chrome",
    },
    {key: "Polished Steel", label: "Polished Steel", value: "Polished Steel"},
    {key: "Intelligent", label: "Intelligent", value: "Intelligent"},
    {key: "Hand Scraped", label: "Hand Scraped", value: "Hand Scraped"},
  ],
  plug_type: [
    {
      key: "A",
      label: "A - Two flat parallel plugs. American type.",
      value: "A",
    },
    {
      key: "B",
      label:
        "B - Two flat parallel plugs with ground plug. American type with ground plug.",
      value: "B",
    },
    {key: "C", label: "C - Two round plugs. French type.", value: "C"},
    {
      key: "D",
      label:
        "D - Two round plugs with ground plug. French type with ground plug.",
      value: "D",
    },
    {
      key: "E",
      label: "E - Two round plugs with male ground plug.",
      value: "E",
    },
    {key: "F", label: "F - Schuko type with two ground plugs.", value: "F"},
    {key: "G", label: "G - Square plugs. British type.", value: "G"},
    {key: "H", label: "H - V plugs with ground plug.", value: "H"},
    {key: "I", label: "I - Inversed V plugs with ground plug.", value: "I"},
    {key: "J", label: "J - Round plug with ground plug.", value: "J"},
    {
      key: "K",
      label: "K - Plug-in plugs: rectangular with ground plug.",
      value: "K",
    },
    {
      key: "L",
      label: "L - Round plugs with aligned ground plug.",
      value: "L",
    },
    {
      key: "M",
      label: "M - Two large round plugs with ground plug.",
      value: "M",
    },
  ],
  special_features: [
    {key: "Auto on/off", label: "Auto on/off", value: "Auto on/off"},
    {key: "Built in timer", label: "Built in timer", value: "Built in timer"},
    {key: "Dimmable", label: "Dimmable", value: "Dimmable"},
    {key: "Lap timer", label: "Lap timer", value: "Lap timer"},
    {
      key: "Back up battery",
      label: "Back up battery",
      value: "Back up battery",
    },
    {key: "Bike computer", label: "Bike computer", value: "Bike computer"},
    {key: "Calculator", label: "Calculator", value: "Calculator"},
    {key: "Chronograph", label: "Chronograph", value: "Chronograph"},
    {key: "Compass GPS", label: "Compass GPS", value: "Compass GPS"},
    {
      key: "Depth measurement",
      label: "Depth measurement",
      value: "Depth measurement",
    },
    {
      key: "Dual time display",
      label: "Dual time display",
      value: "Dual time display",
    },
    {
      key: "Heart rate monitor",
      label: "Heart rate monitor",
      value: "Heart rate monitor",
    },
    {key: "Light", label: "Light", value: "Light"},
    {key: "Luminous", label: "Luminous", value: "Luminous"},
    {
      key: "Outdoor computer",
      label: "Outdoor computer",
      value: "Outdoor computer",
    },
    {
      key: "Radio Controlled",
      label: "Radio Controlled",
      value: "Radio Controlled",
    },
    {
      key: "Screw down crown",
      label: "Screw down crown",
      value: "Screw down crown",
    },
    {key: "Second hand", label: "Second hand", value: "Second hand"},
    {
      key: "Shock resistant",
      label: "Shock resistant",
      value: "Shock resistant",
    },
    {key: "Slide rule", label: "Slide rule", value: "Slide rule"},
    {key: "Stop watch", label: "Stop watch", value: "Stop watch"},
    {key: "Tachometer", label: "Tachometer", value: "Tachometer"},
    {key: "Timer", label: "Timer", value: "Timer"},
    {key: "World time", label: "World time", value: "World time"},
    {
      key: "20 degree wire colated",
      label: "20 degree wire colated",
      value: "20 degree wire colated",
    },
    {
      key: "28 degree plastic coated",
      label: "28 degree plastic coated",
      value: "28 degree plastic coated",
    },
    {
      key: "32 degree paper colated",
      label: "32 degree paper colated",
      value: "32 degree paper colated",
    },
    {
      key: "adjustable shoe",
      label: "adjustable shoe",
      value: "adjustable shoe",
    },
    {
      key: "Air inlet thread size (NPT)",
      label: "Air inlet thread size (NPT)",
      value: "Air inlet thread size (NPT)",
    },
    {key: "Bell", label: "Bell", value: "Bell"},
    {key: "Carbide height", label: "Carbide height", value: "Carbide height"},
    {key: "Contact points", label: "Contact points", value: "Contact points"},
    {
      key: "Diode 635 nanometers",
      label: "Diode 635 nanometers",
      value: "Diode 635 nanometers",
    },
    {
      key: "Dust collection",
      label: "Dust collection",
      value: "Dust collection",
    },
    {
      key: "Dust cycle percentage",
      label: "Dust cycle percentage",
      value: "Dust cycle percentage",
    },
    {
      key: "Dust cycle time",
      label: "Dust cycle time",
      value: "Dust cycle time",
    },
    {key: "Electric brake", label: "Electric brake", value: "Electric brake"},
    {key: "Electrical", label: "Electrical", value: "Electrical"},
    {
      key: "Electrode thickness 1/4 inch",
      label: "Electrode thickness 1/4 inch",
      value: "Electrode thickness 1/4 inch",
    },
    {
      key: "Electrode type copper",
      label: "Electrode type copper",
      value: "Electrode type copper",
    },
    {
      key: "Electrode type mild steel",
      label: "Electrode type mild steel",
      value: "Electrode type mild steel",
    },
    {key: "Extra height", label: "Extra height", value: "Extra height"},
    {key: "Flag", label: "Flag", value: "Flag"},
    {key: "Hose size", label: "Hose size", value: "Hose size"},
    {
      key: "Impact resistance",
      label: "Impact resistance",
      value: "Impact resistance",
    },
    {
      key: "Keyless features",
      label: "Keyless features",
      value: "Keyless features",
    },
    {key: "Latch throw", label: "Latch throw", value: "Latch throw"},
    {
      key: "Lighting interface",
      label: "Lighting interface",
      value: "Lighting interface",
    },
    {key: "Lockable", label: "Lockable", value: "Lockable"},
    {key: "Magnetic", label: "Magnetic", value: "Magnetic"},
    {key: "Mute", label: "Mute", value: "Mute"},
    {key: "Name plate", label: "Name plate", value: "Name plate"},
    {key: "Newspaper roll", label: "Newspaper roll", value: "Newspaper roll"},
    {key: "Night vision", label: "Night vision", value: "Night vision"},
    {key: "Orbital action", label: "Orbital action", value: "Orbital action"},
    {key: "Outlets", label: "Outlets", value: "Outlets"},
    {key: "Paintable", label: "Paintable", value: "Paintable"},
    {key: "Panic button", label: "Panic button", value: "Panic button"},
    {key: "Portable", label: "Portable", value: "Portable"},
    {key: "Positive stop", label: "Positive stop", value: "Positive stop"},
    {
      key: "Rechargeable battery",
      label: "Rechargeable battery",
      value: "Rechargeable battery",
    },
    {key: "Removable", label: "Removable", value: "Removable"},
    {
      key: "Self Ttghtening",
      label: "Self Ttghtening",
      value: "Self Ttghtening",
    },
    {key: "Variable speed", label: "Variable speed", value: "Variable speed"},
    {key: "Video", label: "Video", value: "Video"},
    {key: "Washable", label: "Washable", value: "Washable"},
    {key: "Waterproof", label: "Waterproof", value: "Waterproof"},
    {key: "Wheels", label: "Wheels", value: "Wheels"},
    {key: "Wireless", label: "Wireless", value: "Wireless"},
    {
      key: "2-way switching",
      label: "2-way switching",
      value: "2-way switching",
    },
    {
      key: "Shatter resistant",
      label: "Shatter resistant",
      value: "Shatter resistant",
    },
    {
      key: "Shock and vibration resistant",
      label: "Shock and vibration resistant",
      value: "Shock and vibration resistant",
    },
    {
      key: "Non bug attracting",
      label: "Non bug attracting",
      value: "Non bug attracting",
    },
    {
      key: "3 way switching",
      label: "3 way switching",
      value: "3 way switching",
    },
  ],
  item_weight_unit_of_measure: [
    {key: "pound_(lb)", label: "Pound (LB)", value: "Pound (LB)"},
    {key: "kilogram_(kg)", label: "Kilogram (KG)", value: "Kilogram (KG)"},
    {key: "gram_(gr)", label: "Gram (GR)", value: "Gram (GR)"},
    {
      key: "hundredths_pounds",
      label: "Hundredths pounds",
      value: "Hundredths pounds",
    },
    {key: "milligram_(mg)", label: "Milligram (MG)", value: "Milligram (MG)"},
    {key: "tons", label: "Tons", value: "Tons"},
    {key: "ounce_(oz)", label: "Ounce (OZ)", value: "Ounce (OZ)"},
  ],
  item_volume_unit_of_measure: [
    {key: "cup", label: "Cup", value: "Cup"},
    {key: "microliters", label: "Microliters", value: "Microliters"},
    {key: "cubic-ft", label: "Cubic Feet", value: "Cubic Feet"},
    {key: "centiliters", label: "Centiliters", value: "Centiliters"},
    {key: "gallon", label: "Gallon", value: "Gallon"},
    {key: "quarts", label: "Quarts", value: "Quarts"},
    {key: "nanoliters", label: "Nanoliters", value: "Nanoliters"},
    {key: "liter", label: "Liter", value: "Liter"},
    {key: "picoliters", label: "Picoliters", value: "Picoliters"},
    {
      key: "unknown_modifier",
      label: "Unknown Modifier",
      value: "Unknown Modifier",
    },
    {key: "fluid_ounces", label: "Fluid Ounces", value: "Fluid Ounces"},
    {key: "cubic-m", label: "Cubic Meters", value: "Cubic Meters"},
    {key: "pints", label: "Pints", value: "Pints"},
    {key: "cubic-yd", label: "Cubic Yards", value: "Cubic Yards"},
    {key: "cubic-in", label: "Cubic Inches", value: "Cubic Inches"},
    {
      key: "imperial_gallons",
      label: "Imperial Gallons",
      value: "Imperial Gallons",
    },
    {key: "milliliter", label: "Milliliters", value: "Milliliters"},
    {key: "cubic-cm", label: "Cubic Centimeters", value: "Cubic Centimeters"},
    {key: "deciliters", label: "Deciliters", value: "Deciliters"},
  ],
  battery_type: [
    {
      key: "Battery type AA",
      value: "Battery type AA",
      label: "Battery type AA",
    },
    {
      key: "Battery type AAA",
      value: "Battery type AAA",
      label: "Battery type AAA",
    },
    {
      key: "Battery type lithium ion",
      value: "Battery type lithium ion",
      label: "Battery type lithium ion",
    },
    {key: "Battery type A", value: "Battery type A", label: "Battery type A"},
    {
      key: "Battery type CR2",
      value: "Battery type CR2",
      label: "Battery type CR2",
    },
    {key: "Battery type C", value: "Battery type C", label: "Battery type C"},
    {key: "Battery type D", value: "Battery type D", label: "Battery type D"},
    {
      key: "Battery type CR5",
      value: "Battery type CR5",
      label: "Battery type CR5",
    },
    {key: "AAAA battery", value: "AAAA battery", label: "AAAA battery"},
    {
      key: "battery type P76",
      value: "Battery type P76",
      label: "Battery type P76",
    },
    {
      key: "Battery type product specific",
      value: "Battery type product specific",
      label: "Battery type product specific",
    },
    {key: "Lithiumpolymer", value: "Lithiumpolymer", label: "Lithiumpolymer"},
    {key: "Unknown", value: "Unknown", label: "Unknown"},
    {
      key: "Battery type lithium metal",
      value: "Battery type lithium metal",
      label: "Battery type lithium metal",
    },
    {
      key: "Nonstandard battery",
      value: "Nonstandard battery",
      label: "Nonstandard battery",
    },
    {
      key: "Battery type CR123A",
      value: "Battery type CR123A",
      label: "Battery type CR123A",
    },
    {key: "lr44", value: "lr44", label: "lr44"},
    {key: "12V battery", value: "12V battery", label: "12V battery"},
    {
      key: "Battery type 9V",
      value: "Battery type 9V",
      label: "Battery type 9V",
    },
  ],
  warranty_term: [
    {
      key: "3 months warranty",
      label: "3 months warranty",
      value: "3 months warranty",
    },
    {
      key: "4 months warranty",
      label: "4 months warranty",
      value: "4 months warranty",
    },
    {
      key: "5 months warranty",
      label: "5 months warranty",
      value: "5 months warranty",
    },
    {
      key: "6 months warranty",
      label: "6 months warranty",
      value: "6 months warranty",
    },
    {
      key: "7 months warranty",
      label: "7 months warranty",
      value: "7 months warranty",
    },
    {
      key: "8 months warranty",
      label: "8 months warranty",
      value: "8 months warranty",
    },
    {
      key: "9 months warranty",
      label: "9 months warranty",
      value: "9 months warranty",
    },
    {
      key: "10 months warranty",
      label: "10 months warranty",
      value: "10 months warranty",
    },
    {
      key: "11 months warranty",
      label: "11 months warranty",
      value: "11 months warranty",
    },
    {
      key: "1 year warranty",
      label: "1 year warranty",
      value: "1 year warranty",
    },
    {
      key: "2 years warranty",
      label: "2 years warranty",
      value: "2 years warranty",
    },
    {
      key: "3 years warranty",
      label: "3 years warranty",
      value: "3 years warranty",
    },
    {
      key: "4 years warranty",
      label: "4 years warranty",
      value: "4 years warranty",
    },
    {
      key: "5 years warranty",
      label: "5 years warranty",
      value: "5 years warranty",
    },
    {
      key: "6 years warranty",
      label: "6 years warranty",
      value: "6 years warranty",
    },
    {
      key: "7 years warranty",
      label: "7 years warranty",
      value: "7 years warranty",
    },
    {
      key: "8 years warranty",
      label: "8 years warranty",
      value: "8 years warranty",
    },
    {
      key: "9 years warranty",
      label: "9 years warranty",
      value: "9 years warranty",
    },
    {
      key: "10 years warranty",
      label: "10 years warranty",
      value: "10 years warranty",
    },
    {
      key: "11 years warranty",
      label: "11 years warranty",
      value: "11 years warranty",
    },
    {
      key: "12 years warranty",
      label: "12 years warranty",
      value: "12 years warranty",
    },
    {
      key: "13 years warranty",
      label: "13 years warranty",
      value: "13 years warranty",
    },
    {
      key: "14 years warranty",
      label: "14 years warranty",
      value: "14 years warranty",
    },
    {
      key: "15 years warranty",
      label: "15 years warranty",
      value: "15 years warranty",
    },
    {
      key: "Lifetime warranty",
      label: "Lifetime warranty",
      value: "Lifetime warranty",
    },
    {
      key: "13 months warranty",
      label: "13 months warranty",
      value: "13 months warranty",
    },
    {
      key: "14 months warranty",
      label: "14 months warranty",
      value: "14 months warranty",
    },
    {
      key: "15 months warranty",
      label: "15 months warranty",
      value: "15 months warranty",
    },
    {
      key: "16 months warranty",
      label: "16 months warranty",
      value: "16 months warranty",
    },
    {
      key: "17 months warranty",
      label: "17 months warranty",
      value: "17 months warranty",
    },
    {
      key: "18 months warranty",
      label: "18 months warranty",
      value: "18 months warranty",
    },
    {
      key: "19 months warranty",
      label: "19 months warranty",
      value: "19 months warranty",
    },
    {
      key: "20 months warranty",
      label: "20 months warranty",
      value: "20 months warranty",
    },
    {
      key: "21 months warranty",
      label: "21 months warranty",
      value: "21 months warranty",
    },
    {
      key: "22 months warranty",
      label: "22 months warranty",
      value: "22 months warranty",
    },
    {
      key: "23 months warranty",
      label: "23 months warranty",
      value: "23 months warranty",
    },
  ],
  return_refund_criteria: [
    {
      key: "7 days free return",
      label: "7 days free return",
      value: "7 days free return",
    },
    {
      key: "No return or refund",
      label: "No return or refund",
      value: "no return or refund",
    },
    {
      key: "14 days free return",
      label: "14 days free return",
      value: "14 days free return",
    },
    {
      key: "30 days free return",
      label: "30 days free return",
      value: "30 days free return",
    },
  ],
  "Comission Percent": [
    0.15, 0.1, 0.075, 0.05, 0.03, 0.3, 0.29, 0.28, 0.27, 0.26, 0.25, 0.24, 0.23,
    0.22, 0.21, 0.2, 0.19, 0.18, 0.17, 0.16, 0.14, 0.13, 0.12, 0.11, 0.09, 0.08,
    0.07, 0.06, 0.04,
  ],
  "MOB cities": [
    "Chennai",
    "Hyderabad",
    "Delhi NCR",
    "Bengaluru",
    "Mumbai",
    "Kochi",
    "Jaipur",
    "Chandigarh",
    "Coimbatore",
    "Goa",
    "Kolkata",
    "Mysore",
  ],
  "MOB personnel name ID": [
    "Kumar Vivek (0001)",
    "Johann Elias Terfurth (0002)",
  ],
  variation_theme: [
    {key: "width", label: "Width", value: "Width"},
    {key: "display_weight", label: "Display weight", value: "Display weight"},
    {
      key: "number_of_items",
      label: "Number of items",
      value: "Number of items",
    },
    {
      key: "color_name_+_number_of_items",
      label: "Color name + number of items",
      value: "Color name + number of items",
    },
    {
      key: "size_name_+_number_of_items",
      label: "Size name + number of items",
      value: "Size name + number of items",
    },
    {key: "material", label: "Material", value: "Material"},
    {
      key: "material_+_size",
      label: "Material + size",
      value: "Material + size",
    },
    {key: "pattern_name", label: "Pattern name", value: "Pattern name"},
    {key: "size_name", label: "Size name", value: "Size name"},
    {
      key: "size_name_+_color_name",
      label: "Size name + color name",
      value: "Size name + color name",
    },
    {key: "display_height", label: "Display height", value: "Display height"},
    {key: "color_name", label: "Color name", value: "Color name"},
    {key: "pattern", label: "Pattern", value: "Pattern"},
    {
      key: "display_height_+_display_length",
      label: "Display height + display length",
      value: "Display height + display length",
    },
    {key: "display_length", label: "Display length", value: "Display length"},
    {key: "display_width", label: "Display width", value: "Display width"},
    {key: "volume", label: "Volume", value: "Volume"},
    {key: "colour+volume", label: "Colour+Volume", value: "Colour+Volume"},
    {key: "colour+weight", label: "Colour+Weight", value: "Colour+Weight"},
    {
      key: "display_length_+_display_width",
      label: "Display length + display width",
      value: "Display length + display width",
    },
  ],
  country: [
    {key: "Afghanistan", label: "Afghanistan", value: "Afghanistan"},
    {key: "Aland Islands", label: "Aland Islands", value: "Aland Islands"},
    {key: "Albania", label: "Albania", value: "Albania"},
    {key: "Algeria", label: "Algeria", value: "Algeria"},
    {key: "American Samoa", label: "American Samoa", value: "American Samoa"},
    {key: "Andorra", label: "Andorra", value: "Andorra"},
    {key: "Angola", label: "Angola", value: "Angola"},
    {key: "Anguilla", label: "Anguilla", value: "Anguilla"},
    {key: "Antarctica", label: "Antarctica", value: "Antarctica"},
    {
      key: "Antigua and Barbuda",
      label: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
    },
    {key: "Argentina", label: "Argentina", value: "Argentina"},
    {key: "Armenia", label: "Armenia", value: "Armenia"},
    {key: "Aruba", label: "Aruba", value: "Aruba"},
    {key: "Australia", label: "Australia", value: "Australia"},
    {key: "Austria", label: "Austria", value: "Austria"},
    {key: "Azerbaijan", label: "Azerbaijan", value: "Azerbaijan"},
    {key: "Bahamas", label: "Bahamas", value: "Bahamas"},
    {key: "Bahrain", label: "Bahrain", value: "Bahrain"},
    {key: "Bangladesh", label: "Bangladesh", value: "Bangladesh"},
    {key: "Barbados", label: "Barbados", value: "Barbados"},
    {key: "Belarus", label: "Belarus", value: "Belarus"},
    {key: "Belgium", label: "Belgium", value: "Belgium"},
    {key: "Belize", label: "Belize", value: "Belize"},
    {key: "Benin", label: "Benin", value: "Benin"},
    {key: "Bermuda", label: "Bermuda", value: "Bermuda"},
    {key: "Bhutan", label: "Bhutan", value: "Bhutan"},
    {key: "Bolivia", label: "Bolivia", value: "Bolivia"},
    {
      key: "Bosnia and Herzegovina",
      label: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
    },
    {key: "Botswana", label: "Botswana", value: "Botswana"},
    {key: "Bouvet Island", label: "Bouvet Island", value: "Bouvet Island"},
    {key: "Brazil", label: "Brazil", value: "Brazil"},
    {
      key: "British Virgin Islands",
      label: "British Virgin Islands",
      value: "British Virgin Islands",
    },
    {
      key: "British Indian Ocean Territory",
      label: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
    },
    {
      key: "Brunei Darussalam",
      label: "Brunei Darussalam",
      value: "Brunei Darussalam",
    },
    {key: "Bulgaria", label: "Bulgaria", value: "Bulgaria"},
    {key: "Burkina Faso", label: "Burkina Faso", value: "Burkina Faso"},
    {key: "Burundi", label: "Burundi", value: "Burundi"},
    {key: "Cambodia", label: "Cambodia", value: "Cambodia"},
    {key: "Cameroon", label: "Cameroon", value: "Cameroon"},
    {key: "Canada", label: "Canada", value: "Canada"},
    {key: "Cape Verde", label: "Cape Verde", value: "Cape Verde"},
    {key: "Cayman Islands", label: "Cayman Islands", value: "Cayman Islands"},
    {
      key: "Central African Republic",
      label: "Central African Republic",
      value: "Central African Republic",
    },
    {key: "Chad", label: "Chad", value: "Chad"},
    {key: "Chile", label: "Chile", value: "Chile"},
    {key: "China", label: "China", value: "China"},
    {key: "Hong Kong", label: "Hong Kong", value: "Hong Kong"},
    {key: "Macao", label: "Macao", value: "Macao"},
    {
      key: "Christmas Island",
      label: "Christmas Island",
      value: "Christmas Island",
    },
    {
      key: "Cocos (Keeling) Islands",
      label: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
    },
    {key: "Colombia", label: "Colombia", value: "Colombia"},
    {key: "Comoros", label: "Comoros", value: "Comoros"},
    {
      key: "Congo (Brazzaville)",
      label: "Congo (Brazzaville)",
      value: "Congo (Brazzaville)",
    },
    {key: "Congo", label: "Congo", value: "Congo"},
    {key: "Cook Islands", label: "Cook Islands", value: "Cook Islands"},
    {key: "Costa Rica", label: "Costa Rica", value: "Costa Rica"},
    {key: "Côte d'Ivoire", label: "Côte d'Ivoire", value: "Côte d'Ivoire"},
    {key: "Croatia", label: "Croatia", value: "Croatia"},
    {key: "Cuba", label: "Cuba", value: "Cuba"},
    {key: "Cyprus", label: "Cyprus", value: "Cyprus"},
    {key: "Czech Republic", label: "Czech Republic", value: "Czech Republic"},
    {key: "Denmark", label: "Denmark", value: "Denmark"},
    {key: "Djibouti", label: "Djibouti", value: "Djibouti"},
    {key: "Dominica", label: "Dominica", value: "Dominica"},
    {
      key: "Dominican Republic",
      label: "Dominican Republic",
      value: "Dominican Republic",
    },
    {key: "Ecuador", label: "Ecuador", value: "Ecuador"},
    {key: "Egypt", label: "Egypt", value: "Egypt"},
    {key: "El Salvador", label: "El Salvador", value: "El Salvador"},
    {
      key: "Equatorial Guinea",
      label: "Equatorial Guinea",
      value: "Equatorial Guinea",
    },
    {key: "Eritrea", label: "Eritrea", value: "Eritrea"},
    {key: "Estonia", label: "Estonia", value: "Estonia"},
    {key: "Ethiopia", label: "Ethiopia", value: "Ethiopia"},
    {
      key: "Falkland Islands (Malvinas)",
      label: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
    },
    {key: "Faroe Islands", label: "Faroe Islands", value: "Faroe Islands"},
    {key: "Fiji", label: "Fiji", value: "Fiji"},
    {key: "Finland", label: "Finland", value: "Finland"},
    {key: "France", label: "France", value: "France"},
    {key: "French Guiana", label: "French Guiana", value: "French Guiana"},
    {
      key: "French Polynesia",
      label: "French Polynesia",
      value: "French Polynesia",
    },
    {
      key: "French Southern Territories",
      label: "French Southern Territories",
      value: "French Southern Territories",
    },
    {key: "Gabon", label: "Gabon", value: "Gabon"},
    {key: "Gambia", label: "Gambia", value: "Gambia"},
    {key: "Georgia", label: "Georgia", value: "Georgia"},
    {key: "Germany", label: "Germany", value: "Germany"},
    {key: "Ghana", label: "Ghana", value: "Ghana"},
    {key: "Gibraltar", label: "Gibraltar", value: "Gibraltar"},
    {key: "Greece", label: "Greece", value: "Greece"},
    {key: "Greenland", label: "Greenland", value: "Greenland"},
    {key: "Grenada", label: "Grenada", value: "Grenada"},
    {key: "Guadeloupe", label: "Guadeloupe", value: "Guadeloupe"},
    {key: "Guam", label: "Guam", value: "Guam"},
    {key: "Guatemala", label: "Guatemala", value: "Guatemala"},
    {key: "Guernsey", label: "Guernsey", value: "Guernsey"},
    {key: "Guinea", label: "Guinea", value: "Guinea"},
    {key: "Guinea-Bissau", label: "Guinea-Bissau", value: "Guinea-Bissau"},
    {key: "Guyana", label: "Guyana", value: "Guyana"},
    {key: "Haiti", label: "Haiti", value: "Haiti"},
    {
      key: "Heard Island and Mcdonald Islands",
      label: "Heard Island and Mcdonald Islands",
      value: "Heard Island and Mcdonald Islands",
    },
    {
      key: "Holy See (Vatican City State)",
      label: "Holy See (Vatican City State)",
      value: "Holy See (Vatican City State)",
    },
    {key: "Honduras", label: "Honduras", value: "Honduras"},
    {key: "Hungary", label: "Hungary", value: "Hungary"},
    {key: "Iceland", label: "Iceland", value: "Iceland"},
    {key: "India", label: "India", value: "India"},
    {key: "Indonesia", label: "Indonesia", value: "Indonesia"},
    {key: "Iran", label: "Iran", value: "Iran"},
    {key: "Iraq", label: "Iraq", value: "Iraq"},
    {key: "Ireland", label: "Ireland", value: "Ireland"},
    {key: "Isle of Man", label: "Isle of Man", value: "Isle of Man"},
    {key: "Israel", label: "Israel", value: "Israel"},
    {key: "Italy", label: "Italy", value: "Italy"},
    {key: "Jamaica", label: "Jamaica", value: "Jamaica"},
    {key: "Japan", label: "Japan", value: "Japan"},
    {key: "Jersey", label: "Jersey", value: "Jersey"},
    {key: "Jordan", label: "Jordan", value: "Jordan"},
    {key: "Kazakhstan", label: "Kazakhstan", value: "Kazakhstan"},
    {key: "Kenya", label: "Kenya", value: "Kenya"},
    {key: "Kiribati", label: "Kiribati", value: "Kiribati"},
    {key: "North Korea", label: "North Korea", value: "North Korea"},
    {key: "South Korea", label: "South Korea", value: "South Korea"},
    {key: "Kuwait", label: "Kuwait", value: "Kuwait"},
    {key: "Kyrgyzstan", label: "Kyrgyzstan", value: "Kyrgyzstan"},
    {key: "Lao PDR", label: "Lao PDR", value: "Lao PDR"},
    {key: "Latvia", label: "Latvia", value: "Latvia"},
    {key: "Lebanon", label: "Lebanon", value: "Lebanon"},
    {key: "Lesotho", label: "Lesotho", value: "Lesotho"},
    {key: "Liberia", label: "Liberia", value: "Liberia"},
    {key: "Libya", label: "Libya", value: "Libya"},
    {key: "Liechtenstein", label: "Liechtenstein", value: "Liechtenstein"},
    {key: "Lithuania", label: "Lithuania", value: "Lithuania"},
    {key: "Luxembourg", label: "Luxembourg", value: "Luxembourg"},
    {key: "Macedonia", label: "Macedonia", value: "Macedonia"},
    {key: "Madagascar", label: "Madagascar", value: "Madagascar"},
    {key: "Malawi", label: "Malawi", value: "Malawi"},
    {key: "Malaysia", label: "Malaysia", value: "Malaysia"},
    {key: "Maldives", label: "Maldives", value: "Maldives"},
    {key: "Mali", label: "Mali", value: "Mali"},
    {key: "Malta", label: "Malta", value: "Malta"},
    {
      key: "Marshall Islands",
      label: "Marshall Islands",
      value: "Marshall Islands",
    },
    {key: "Martinique", label: "Martinique", value: "Martinique"},
    {key: "Mauritania", label: "Mauritania", value: "Mauritania"},
    {key: "Mauritius", label: "Mauritius", value: "Mauritius"},
    {key: "Mayotte", label: "Mayotte", value: "Mayotte"},
    {key: "Mexico", label: "Mexico", value: "Mexico"},
    {key: "Micronesia", label: "Micronesia", value: "Micronesia"},
    {key: "Moldova", label: "Moldova", value: "Moldova"},
    {key: "Monaco", label: "Monaco", value: "Monaco"},
    {key: "Mongolia", label: "Mongolia", value: "Mongolia"},
    {key: "Montenegro", label: "Montenegro", value: "Montenegro"},
    {key: "Montserrat", label: "Montserrat", value: "Montserrat"},
    {key: "Morocco", label: "Morocco", value: "Morocco"},
    {key: "Mozambique", label: "Mozambique", value: "Mozambique"},
    {key: "Myanmar", label: "Myanmar", value: "Myanmar"},
    {key: "Namibia", label: "Namibia", value: "Namibia"},
    {key: "Nauru", label: "Nauru", value: "Nauru"},
    {key: "Nepal", label: "Nepal", value: "Nepal"},
    {key: "Netherlands", label: "Netherlands", value: "Netherlands"},
    {
      key: "Netherlands Antilles",
      label: "Netherlands Antilles",
      value: "Netherlands Antilles",
    },
    {key: "New Caledonia", label: "New Caledonia", value: "New Caledonia"},
    {key: "New Zealand", label: "New Zealand", value: "New Zealand"},
    {key: "Nicaragua", label: "Nicaragua", value: "Nicaragua"},
    {key: "Niger", label: "Niger", value: "Niger"},
    {key: "Nigeria", label: "Nigeria", value: "Nigeria"},
    {key: "Niue", label: "Niue", value: "Niue"},
    {key: "Norfolk Island", label: "Norfolk Island", value: "Norfolk Island"},
    {
      key: "Northern Mariana Islands",
      label: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
    },
    {key: "Norway", label: "Norway", value: "Norway"},
    {key: "Oman", label: "Oman", value: "Oman"},
    {key: "Pakistan", label: "Pakistan", value: "Pakistan"},
    {key: "Palau", label: "Palau", value: "Palau"},
    {key: "Palestine", label: "Palestine", value: "Palestine"},
    {key: "Panama", label: "Panama", value: "Panama"},
    {
      key: "Papua New Guinea",
      label: "Papua New Guinea",
      value: "Papua New Guinea",
    },
    {key: "Paraguay", label: "Paraguay", value: "Paraguay"},
    {key: "Peru", label: "Peru", value: "Peru"},
    {key: "Philippines", label: "Philippines", value: "Philippines"},
    {key: "Pitcairn", label: "Pitcairn", value: "Pitcairn"},
    {key: "Poland", label: "Poland", value: "Poland"},
    {key: "Portugal", label: "Portugal", value: "Portugal"},
    {key: "Puerto Rico", label: "Puerto Rico", value: "Puerto Rico"},
    {key: "Qatar", label: "Qatar", value: "Qatar"},
    {key: "Réunion", label: "Réunion", value: "Réunion"},
    {key: "Romania", label: "Romania", value: "Romania"},
    {key: "Russia", label: "Russia", value: "Russia"},
    {key: "Rwanda", label: "Rwanda", value: "Rwanda"},
    {
      key: "Saint-Barthélemy",
      label: "Saint-Barthélemy",
      value: "Saint-Barthélemy",
    },
    {key: "Saint Helena", label: "Saint Helena", value: "Saint Helena"},
    {
      key: "Saint Kitts and Nevis",
      label: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
    },
    {key: "Saint Lucia", label: "Saint Lucia", value: "Saint Lucia"},
    {
      key: "Saint-Martin (French part)",
      label: "Saint-Martin (French part)",
      value: "Saint-Martin (French part)",
    },
    {
      key: "Saint Pierre and Miquelon",
      label: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
    },
    {
      key: "Saint Vincent and Grenadines",
      label: "Saint Vincent and Grenadines",
      value: "Saint Vincent and Grenadines",
    },
    {key: "Samoa", label: "Samoa", value: "Samoa"},
    {key: "San Marino", label: "San Marino", value: "San Marino"},
    {
      key: "Sao Tome and Principe",
      label: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
    },
    {key: "Saudi Arabia", label: "Saudi Arabia", value: "Saudi Arabia"},
    {key: "Senegal", label: "Senegal", value: "Senegal"},
    {key: "Serbia", label: "Serbia", value: "Serbia"},
    {key: "Seychelles", label: "Seychelles", value: "Seychelles"},
    {key: "Sierra Leone", label: "Sierra Leone", value: "Sierra Leone"},
    {key: "Singapore", label: "Singapore", value: "Singapore"},
    {key: "Slovakia", label: "Slovakia", value: "Slovakia"},
    {key: "Slovenia", label: "Slovenia", value: "Slovenia"},
    {
      key: "Solomon Islands",
      label: "Solomon Islands",
      value: "Solomon Islands",
    },
    {key: "Somalia", label: "Somalia", value: "Somalia"},
    {key: "South Africa", label: "South Africa", value: "South Africa"},
    {
      key: "South Georgia and the South Sandwich Islands",
      label: "South Georgia and the South Sandwich Islands",
      value: "South Georgia and the South Sandwich Islands",
    },
    {key: "South Sudan", label: "South Sudan", value: "South Sudan"},
    {key: "Spain", label: "Spain", value: "Spain"},
    {key: "Sri Lanka", label: "Sri Lanka", value: "Sri Lanka"},
    {key: "Sudan", label: "Sudan", value: "Sudan"},
    {key: "Suriname", label: "Suriname", value: "Suriname"},
    {
      key: "Svalbard and Jan Mayen Islands",
      label: "Svalbard and Jan Mayen Islands",
      value: "Svalbard and Jan Mayen Islands",
    },
    {key: "Swaziland", label: "Swaziland", value: "Swaziland"},
    {key: "Sweden", label: "Sweden", value: "Sweden"},
    {key: "Switzerland", label: "Switzerland", value: "Switzerland"},
    {
      key: "Syrian Arab Republic (Syria)",
      label: "Syrian Arab Republic (Syria)",
      value: "Syrian Arab Republic (Syria)",
    },
    {key: "Taiwan", label: "Taiwan", value: "Taiwan"},
    {key: "Tajikistan", label: "Tajikistan", value: "Tajikistan"},
    {key: "Tanzania", label: "Tanzania", value: "Tanzania"},
    {key: "Thailand", label: "Thailand", value: "Thailand"},
    {key: "Timor-Leste", label: "Timor-Leste", value: "Timor-Leste"},
    {key: "Togo", label: "Togo", value: "Togo"},
    {key: "Tokelau", label: "Tokelau", value: "Tokelau"},
    {key: "Tonga", label: "Tonga", value: "Tonga"},
    {
      key: "Trinidad and Tobago",
      label: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
    },
    {key: "Tunisia", label: "Tunisia", value: "Tunisia"},
    {key: "Turkey", label: "Turkey", value: "Turkey"},
    {key: "Turkmenistan", label: "Turkmenistan", value: "Turkmenistan"},
    {
      key: "Turks and Caicos Islands",
      label: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
    },
    {key: "Tuvalu", label: "Tuvalu", value: "Tuvalu"},
    {key: "Uganda", label: "Uganda", value: "Uganda"},
    {key: "Ukraine", label: "Ukraine", value: "Ukraine"},
    {
      key: "United Arab Emirates",
      label: "United Arab Emirates",
      value: "United Arab Emirates",
    },
    {key: "United Kingdom", label: "United Kingdom", value: "United Kingdom"},
    {key: "USA", label: "USA", value: "USA"},
    {
      key: "United States Minor Outlying Islands",
      label: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
    },
    {key: "Uruguay", label: "Uruguay", value: "Uruguay"},
    {key: "Uzbekistan", label: "Uzbekistan", value: "Uzbekistan"},
    {key: "Vanuatu", label: "Vanuatu", value: "Vanuatu"},
    {key: "Venezuela", label: "Venezuela", value: "Venezuela"},
    {key: "Vietnam", label: "Vietnam", value: "Vietnam"},
    {
      key: "Virgin Islands, US",
      label: "Virgin Islands, US",
      value: "Virgin Islands, US",
    },
    {
      key: "Wallis and Futuna Islands",
      label: "Wallis and Futuna Islands",
      value: "Wallis and Futuna Islands",
    },
    {key: "Western Sahara", label: "Western Sahara", value: "Western Sahara"},
    {key: "Yemen", label: "Yemen", value: "Yemen"},
    {key: "Zambia", label: "Zambia", value: "Zambia"},
    {key: "Zimbabwe", label: "Zimbabwe", value: "Zimbabwe"},
    {key: "Kosovo", label: "Kosovo", value: "Kosovo"},
    {key: "Scotland", label: "Scotland", value: "Scotland"},
    {key: "Wales", label: "Wales", value: "Wales"},
    {
      key: "Saint Vincent And The Grenadines",
      label: "Saint Vincent And The Grenadines",
      value: "Saint Vincent And The Grenadines",
    },
  ],
  "Fulfillment latency for shipping": [
    "on-demand (< 30mins)",
    "Same day (>2 hour)",
    "Next day ",
    "2 days",
    "Up to 1 week",
    "More than 1 week",
    "Built to order (1 week)",
    "Built to order (2 weeks)",
    "Built to order (1 month)",
    "To be quoted upon request",
  ],
  // unit_count_type: [
  //   {key: "Set", label: "Set", value: "Set"},
  //   {key: "Unit", label: "Unit", value: "Unit"},
  //   {key: "Count", label: "Count", value: "Count"},
  // ],
  unit_count_type: [
    { key: "BAG", label: "BAG (BAGS)", value: "BAG" },
    { key: "BAL", label: "BAL (BALE)", value: "BAL" },
    { key: "BDL", label: "BDL (BUNDLES)", value: "BDL" },
    { key: "BKL", label: "BKL (BUCKLES)", value: "BKL" },
    { key: "BOU", label: "BOU (BILLION OF UNITS)", value: "BOU" },
    { key: "BOX", label: "BOX (BOX)", value: "BOX" },
    { key: "BTL", label: "BTL (BOTTLES)", value: "BTL" },
    { key: "BUN", label: "BUN (BUNCHES)", value: "BUN" },
    { key: "CAN", label: "CAN (CANS)", value: "CAN" },
    { key: "CBM", label: "CBM (CUBIC METERS)", value: "CBM" },
    { key: "CCM", label: "CCM (CUBIC CENTIMETERS)", value: "CCM" },
    { key: "CMS", label: "CMS (CENTIMETERS)", value: "CMS" },
    { key: "CTN", label: "CTN (CARTONS)", value: "CTN" },
    { key: "DOZ", label: "DOZ (DOZENS)", value: "DOZ" },
    { key: "DRM", label: "DRM (DRUMS)", value: "DRM" },
    { key: "GGK", label: "GGK (GREAT GROSS)", value: "GGK" },
    { key: "GMS", label: "GMS (GRAMMES)", value: "GMS" },
    { key: "GRS", label: "GRS (GROSS)", value: "GRS" },
    { key: "GYD", label: "GYD (GROSS YARDS)", value: "GYD" },
    { key: "KGS", label: "KGS (KILOGRAMS)", value: "KGS" },
    { key: "KLR", label: "KLR (KILOLITRE)", value: "KLR" },
    { key: "KME", label: "KME (KILOMETRE)", value: "KME" },
    { key: "LTR", label: "LTR (LITRES)", value: "LTR" },
    { key: "MLT", label: "MLT (MILILITRE)", value: "MLT" },
    { key: "MTR", label: "MTR (METERS)", value: "MTR" },
    { key: "MTS", label: "MTS (METRIC TON)", value: "MTS" },
    { key: "NOS", label: "NOS (NUMBERS)", value: "NOS" },
    { key: "OTH", label: "OTH (OTHERS)", value: "OTH" },
    { key: "PAC", label: "PAC (PACKS)", value: "PAC" },
    { key: "PCS", label: "PCS (PIECES)", value: "PCS" },
    { key: "PRS", label: "PRS (PAIRS)", value: "PRS" },
    { key: "QTL", label: "QTL (QUINTAL)", value: "QTL" },
    { key: "ROL", label: "ROL (ROLLS)", value: "ROL" },
    { key: "SET", label: "SET (SETS)", value: "SET" },
    { key: "SQF", label: "SQF (SQUARE FEET)", value: "SQF" },
    { key: "SQM", label: "SQM (SQUARE METERS)", value: "SQM" },
    { key: "SQY", label: "SQY (SQUARE YARDS)", value: "SQY" },
    { key: "TBS", label: "TBS (TABLETS)", value: "TBS" },
    { key: "TGM", label: "TGM (TEN GROSS)", value: "TGM" },
    { key: "THD", label: "THD (THOUSANDS)", value: "THD" },
    { key: "TON", label: "TON (TONNES)", value: "TON" },
    { key: "TUB", label: "TUB (TUBES)", value: "TUB" },
    { key: "UGS", label: "UGS (US GALLONS)", value: "UGS" },
    { key: "UNT", label: "UNT (UNITS)", value: "UNT" },
    { key: "YDS", label: "YDS (YARDS)", value: "YDS" },
    { key: "TC", label: "TC (Transportation charge)", value: "TC" },
  ],
  item_width_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  item_length_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  item_height_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  conditon_type: [
    {key: "New", label: "New", value: "New"},
    {
      key: "Used - like new",
      label: "Used - like new",
      value: "Used - like new",
    },
    {
      key: "Used - very good",
      label: "Used - very good",
      value: "Used - very good",
    },
    {key: "Used - good", label: "Used - good", value: "Used - good"},
    {
      key: "Used - acceptable",
      label: "Used - acceptable",
      value: "Used - acceptable",
    },
  ],
  currency: [
    {key: "INR", label: "Indian Rupee (INR)", value: "INR"},
    {key: "MXN", label: "Mexican Peso (MXN)", value: "MXN"},
    {key: "EUR", label: "Euro (EUR)", value: "EUR"},
    {key: "GBP", label: "British Pound (GBP)", value: "GBP"},
    {key: "USD", label: "United States Dollar (USD)", value: "USD"},
    {key: "CAD", label: "Canadian Dollar (CAD)", value: "CAD"},
    {key: "JPY", label: "Japanese Yen (JPY)", value: "JPY"},
    {key: "CNY", label: "Chinese Yuan (CNY)", value: "CNY"},
  ],
  variation_type: [
    {key: "parent_only", label: "Parent only", value: "Parent only"},
    {key: "variant", label: "Variant", value: "Variant"},
    {
      key: "parent_with_variant/s",
      label: "Parent with variant/s",
      value: "Parent with variant/s",
    },
  ],
  power_source_type: [
    {key: "AC", label: "AC", value: "AC"},
    {key: "AC/DC", label: "AC/DC", value: "AC/DC"},
    {key: "Air powered", label: "Air powered", value: "Air powered"},
    {
      key: "Battery powered",
      label: "Battery powered",
      value: "Battery powered",
    },
    {
      key: "Corded electric",
      label: "Corded electric",
      value: "Corded electric",
    },
    {key: "Crank", label: "Crank", value: "Crank"},
    {key: "DC", label: "DC", value: "DC"},
    {key: "Gas powered", label: "Gas powered", value: "Gas powered"},
    {key: "Hand powered", label: "Hand powered", value: "Hand powered"},
    {
      key: "Hydraulic powered",
      label: "Hydraulic powered",
      value: "Hydraulic powered",
    },
    {key: "Solar", label: "Solar", value: "Solar"},
    {key: "Fuel powered", label: "Fuel powered", value: "Fuel powered"},
    {key: "Solar powered", label: "Solar powered", value: "Solar powered"},
    {key: "Manual", label: "Manual", value: "Manual"},
  ],
  included_components: [
    {
      key: "30 minute charger",
      label: "30 minute charger",
      value: "30 minute charger",
    },
    {key: "Adapter", label: "Adapter", value: "Adapter"},
    {key: "Bag", label: "Bag", value: "Bag"},
    {key: "Batteries", label: "Batteries", value: "Batteries"},
    {key: "Blade", label: "Blade", value: "Blade"},
    {key: "Block", label: "Block", value: "Block"},
    {key: "Bolts", label: "Bolts", value: "Bolts"},
    {key: "Caps", label: "Caps", value: "Caps"},
    {key: "Caribineer", label: "Caribineer", value: "Caribineer"},
    {key: "Case", label: "Case", value: "Case"},
    {key: "Chain", label: "Chain", value: "Chain"},
    {key: "Charger", label: "Charger", value: "Charger"},
    {
      key: "Circular saw blade",
      label: "Circular saw blade",
      value: "Circular saw blade",
    },
    {
      key: "Comes as a combo set",
      label: "Comes as a combo set",
      value: "Comes as a combo set",
    },
    {
      key: "Compartments included",
      label: "Compartments included",
      value: "Compartments included",
    },
    {key: "Coupling", label: "Coupling", value: "Coupling"},
    {key: "Depth rod", label: "Depth rod", value: "Depth rod"},
    {key: "Detector", label: "Detector", value: "Detector"},
    {key: "Dowel", label: "Dowel", value: "Dowel"},
    {key: "Drill bits", label: "Drill bits", value: "Drill bits"},
    {
      key: "Drywall nosepeice",
      label: "Drywall nosepeice",
      value: "Drywall nosepeice",
    },
    {key: "Fuse", label: "Fuse", value: "Fuse"},
    {key: "Gauge", label: "Gauge", value: "Gauge"},
    {key: "Hammer", label: "Hammer", value: "Hammer"},
    {key: "Hose", label: "Hose", value: "Hose"},
    {key: "Light", label: "Light", value: "Light"},
    {key: "Motor", label: "Motor", value: "Motor"},
    {key: "Nails", label: "Nails", value: "Nails"},
    {key: "Nuts", label: "Nuts", value: "Nuts"},
    {
      key: "One hour charger",
      label: "One hour charger",
      value: "One hour charger",
    },
    {key: "Pads", label: "Pads", value: "Pads"},
    {key: "Pins", label: "Pins", value: "Pins"},
    {key: "Pocket clips", label: "Pocket clips", value: "Pocket clips"},
    {key: "Pump", label: "Pump", value: "Pump"},
    {
      key: "Quick connect fixtures",
      label: "Quick connect fixtures",
      value: "Quick connect fixtures",
    },
    {
      key: "Reciprocating saw blade",
      label: "Reciprocating saw blade",
      value: "Reciprocating saw blade",
    },
    {
      key: "Screwdriver bits",
      label: "Screwdriver bits",
      value: "Screwdriver bits",
    },
    {key: "Screws", label: "Screws", value: "Screws"},
    {
      key: "Shade protector",
      label: "Shade protector",
      value: "Shade protector",
    },
    {key: "Side handle", label: "Side handle", value: "Side handle"},
    {key: "Staples", label: "Staples", value: "Staples"},
    {
      key: "Surge protection",
      label: "Surge protection",
      value: "Surge protection",
    },
    {key: "Switch", label: "Switch", value: "Switch"},
    {key: "TEKS nosepiece", label: "TEKS nosepiece", value: "TEKS nosepiece"},
    {key: "Tacks", label: "Tacks", value: "Tacks"},
    {key: "Valve", label: "Valve", value: "Valve"},
    {key: "Washers", label: "Washers", value: "Washers"},
    {
      key: "Batteries included",
      label: "Batteries included",
      value: "Batteries included",
    },
    {key: "Bulb included", label: "Bulb included", value: "Bulb included"},
    {
      key: "Fan blade included",
      label: "Fan blade included",
      value: "Fan blade included",
    },
    {key: "Fuse", label: "Fuse", value: "Fuse"},
    {
      key: "Light kit included",
      label: "Light kit included",
      value: "Light kit included",
    },
    {key: "Shade included", label: "Shade included", value: "Shade included"},
    {
      key: "Shade protector",
      label: "Shade protector",
      value: "Shade protector",
    },
    {
      key: "Surge protection",
      label: "Surge protection",
      value: "Surge protection",
    },
    {key: "Switch", label: "Switch", value: "Switch"},
    {
      key: "Built-in water filter",
      label: "Built-in water filter",
      value: "Built-in water filter",
    },
    {key: "Toilet bowl", label: "Toilet bowl", value: "Toilet bowl"},
    {key: "Toilet tank", label: "Toilet tank", value: "Toilet tank"},
    {key: "Caribineer", label: "Caribineer", value: "Caribineer"},
    {key: "Handles", label: "Handles", value: "Handles"},
    {
      key: "Includes sidespray",
      label: "Includes sidespray",
      value: "Includes sidespray",
    },
  ],
  "Update delete": ["Update", "Partial update", "Delete"],
  "Short product description": [
    "Metal drill HSS-TiN",
    "Metal drill HHS-G",
    "Concrete drill",
    "Auger bits",
    "Spade",
    "Torx",
    "Inner square screws",
    "Depth stops",
    "Forstner bit",
    "Diamond drill",
    "Countersink drill bit",
    "Metal drill HHS-R",
    "Formwork and installation drill bits",
    "Phillips head screws",
    "Hexagon socket screws",
    "Flexible shafts",
    "Masonary drill bit",
    "Art drill",
    "Screwdriver bit sets",
    "Hinge hole drill",
    "Cross head screws",
    "Tile bit",
    "Crosspoint screws",
    "Wood drill",
    "Multi purpose drill",
    "Connectors",
    "Hammer drill",
    "Level",
    "Socket",
    "Universal holder",
    "Screwdriver bits",
    "Other",
  ],
  pattern_name: [
    {key: "a", label: "A", value: "A"},
    {key: "b", label: "B", value: "B"},
    {key: "c", label: "C", value: "C"},
    {key: "d", label: "D", value: "D"},
    {key: "e", label: "E", value: "E"},
    {key: "f", label: "F", value: "F"},
    {key: "g", label: "G", value: "G"},
    {key: "h", label: "H", value: "H"},
    {key: "i", label: "I", value: "I"},
    {key: "j", label: "J", value: "J"},
    {key: "k", label: "K", value: "K"},
    {key: "l", label: "L", value: "L"},
    {key: "m", label: "M", value: "M"},
    {key: "n", label: "N", value: "N"},
    {key: "o", label: "O", value: "O"},
    {key: "p", label: "P", value: "P"},
    {key: "q", label: "Q", value: "Q"},
    {key: "r", label: "R", value: "R"},
    {key: "s", label: "S", value: "S"},
    {key: "t", label: "T", value: "T"},
    {key: "u", label: "U", value: "U"},
    {key: "v", label: "V", value: "V"},
    {key: "w", label: "W", value: "W"},
    {key: "x", label: "X", value: "X"},
    {key: "y", label: "Y", value: "Y"},
    {key: "z", label: "Z", value: "Z"},
    {key: "0", label: "0", value: "0"},
    {key: "1", label: "1", value: "1"},
    {key: "2", label: "2", value: "2"},
    {key: "3", label: "3", value: "3"},
    {key: "4", label: "4", value: "4"},
    {key: "5", label: "5", value: "5"},
    {key: "6", label: "6", value: "6"},
    {key: "7", label: "7", value: "7"},
    {key: "8", label: "8", value: "8"},
    {key: "9", label: "9", value: "9"},
  ],
};
export const mobileRegex = /^\d{10}$/;
export const checkEmptyValidation = (value) => {
  if (value && value !== "") {
    return true;
  } else {
    return false;
  }
};
export const checkPhoneNumberValidation = (value) => {
  return mobileRegex.test(value);
};
export const checkgstValidation = (value) => {
  if (gstRegex.test(value) && value !== "" && value !== undefined) {
    return true;
  } else {
    return false;
  }
};
export const checkgstOptionalValidation = (value) => {
  if (value) {
    if (gstRegex.test(value)) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const MOB_CREDIT_TAG_CHECK = ["mobCredit"];
